import { useAppStore } from '@/lib/store'

const TRANSLATIONS = {
  uk: {
    common: {
      actionFailed: 'Не вдалося зберегти зміни. Спробуйте ще раз.',
      loading: 'Завантаження...',
      error: 'Помилка завантаження',
      total: 'Разом',
      paid: 'Оплачено',
      unpaid: 'Очікує оплати',
      consentText: 'Ми використовуємо аналітику, щоб покращувати сайт. Продовжуючи, ви погоджуєтесь.',
      consentAccept: 'Погодитись',
      consentDecline: 'Відхилити',
      watchOnYoutube: 'Дивитися на YouTube',
      close: 'Закрити',
    },
    fopModal: {
      title: 'Реквізити для оплати (ФОП / IBAN)',
      subtitle: 'Офіційна оплата через будь-який банк України',
      loading: 'Завантаження реквізитів...',
      notConfigured: 'Реквізити для оплати наразі не налаштовані.',
      recipient: 'Отримувач (ФОП / Підприємство)',
      amount: 'Сума до сплати',
      purpose: 'Призначення платежу',
      bankCard: 'Номер банківської картки',
      extraInfo: 'Додаткова інформація / Банк',
      scanQrHint: 'Відскануйте QR-код у додатку вашого банку для швидкої оплати',
      copyIban: 'Скопіювати IBAN',
      copied: 'Скопійовано!',
    },
    nav: {
      home: 'Головна',
      catalog: 'Каталог',
      quiz: 'Підбір',
      services: 'Послуги',
      auctions: 'Аукціони',
      cart: 'Кошик',
      profile: 'Профіль',
      stories: 'Статті',
      wishlist: 'Бажане',
      brands: 'Бренди',
    },
    brands: {
      officialBrand: 'Офіційний бренд',
      outOfStock: 'Немає в наявності',
      title: 'Бренди',
      allBrands: 'Всі бренди',
      subtitle: 'Оригінальна нішева та селективна парфумерія від світових домів',
      searchPlaceholder: 'Пошук бренду...',
      allLetters: 'Всі',
      productCount: (count: number) => `${count} товар${count === 1 ? '' : count >= 2 && count <= 4 ? 'и' : 'ів'}`,
      noBrandsFound: 'Брендів за вашим запитом не знайдено',
      noProductsFound: 'У цього бренду наразі немає товарів у наявності',
      backToBrands: 'Всі бренди',
      allCategories: 'Всі категорії',
      allGenders: 'Всі статі',
      viewProducts: 'Переглянути товари',
      filterCategory: 'Категорія',
      filterGender: 'Стать',
      sortBy: 'Сортувати',
      sortPopular: 'За популярністю',
      sortPriceAsc: 'Від дешевих до дорогих',
      sortPriceDesc: 'Від дорогих до дешевих',
      sortNewest: 'Новинки',
      priceFrom: 'від',
      aboutBrand: 'Про бренд',
      readMore: 'Читати далі',
      showLess: 'Згорнути',
      viewAllInCatalog: (count: number) => `Дивитися всі товари в каталозі (${count})`,
    },
    specs: {
      title: 'Характеристика',
      allSpecs: 'Всі характеристики',
      backToCatalog: 'До каталогу',
      productsWithSpec: (name: string) => `Товари з характеристикою «${name}»`,
      productCount: (count: number) => `${count} товар${count === 1 ? '' : count >= 2 && count <= 4 ? 'и' : 'ів'}`,
      viewAllInCatalog: (count?: number) => count && count > 0 ? `Дивитися всі товари в каталозі (${count})` : 'Дивитися всі товари в каталозі',
      readMore: 'Читати далі',
      showLess: 'Згорнути',
      noProducts: 'Наразі немає товарів з цією характеристикою',
      aboutAttribute: 'Про характеристику',
      priceFrom: 'від',
      sortBy: 'Сортувати',
      sortPriceAsc: 'Від дешевих до дорогих',
      sortPriceDesc: 'Від дорогих до дешевих',
      sortNewest: 'Новинки',
    },
    home: {

      shopNow: 'До каталогу',
      categoriesTitle: 'Категорії',
      newProductsTitle: 'Новинки',
      quizBannerTitle: 'Підбери свій аромат',
      quizBannerCta: 'Пройти тест',
      mayparfumEyebrow: 'Нішева парфумерія та розпив',
      mayparfumTitle: 'MAY PARFUM',
      mayparfumSubtitle:
        'Оригінальні аромати, деканти та рідкісні флакони для тих, хто хоче спершу відчути історію на шкірі.',
      mayparfumPrimary: 'Обрати аромат',
      mayparfumSecondary: 'Парфумерна культура',
      mayparfumTrust: ['Оригінальність', 'Розпив', 'Швидка відправка'] as string[],
      mayparfumWelcomeEyebrow: 'Вітаємо у світі ароматів',
      mayparfumWelcomeTitle: 'Відкрийте нові горизонти парфумерії',
      mayparfumWelcomeBody:
        'MAY PARFUM — простір нішевої, селективної, авторської та артизанальної парфумерії. Тут можна знайти аромат під настрій, сезон або важливу подію і спокійно познайомитися з ним у зручному форматі.',
      mayparfumBrandsTitle: 'Бренди у добірках',
      mayparfumChannelTitle: 'Актуальні аромати з телеграм-каналу @mayparfum_nspl',
      mayparfumStoriesTitle: 'Парфумерна культура',
      mayparfumStoriesSubtitle: 'Короткі матеріали, які допоможуть вибирати аромат уважніше.',
      mayparfumCatalogHint: 'Дивіться новинки, добірки та аромати під настрій.',
      mayparfumHighlights: [
        {
          title: 'Персоналізований вибір',
          body: 'Добірки за характером, сезоном, подією та улюбленими нотами.',
        },
        {
          title: 'Аромобокси',
          body: 'Зручний формат для знайомства з кількома ароматами перед флаконом.',
        },
        {
          title: 'Парфумерна культура',
          body: 'Статті та огляди, що допомагають краще розуміти композиції.',
        },
      ] as { title: string; body: string }[],
    },
    stories: {
      fragranceQuiz: 'Підбір аромату',
      storiesCultureTitle: 'ПАРФУМЕРНА КУЛЬТУРА',
      storiesCultureSubtitle: 'Парфумерний гід та база знань',
      storiesCultureDescription: 'Все про нішеві аромати, деканти, концентрації, стійкість та правильне нанесення.',
      searchPlaceholder: 'Пошук серед статей та гайдів...',
      noArticlesFound: 'Статей за запитом не знайдено.',
      readGuide: 'Читати гайд',
    },
    quizNav: {
      title: 'Підбір товару',
      step: 'Питання {current} з {total}',
      next: 'Далі',
      back: 'Назад',
      viewResults: 'Переглянути варіанти',
      startOver: 'Почати заново',
      foundCount: 'Знайдено: {count}',
      noMatches: 'Нічого не знайдено — спробуй прибрати кілька відповідей',
      results: 'Результати',
      profileTitle: 'Ваш ольфакторний профіль',
      profileSub: 'Створено на основі ваших вподобань та обраних акордів',
      copyProfile: 'Скопіювати профіль',
      copied: 'Скопійовано!',
      shareProfile: 'Поділитися',
      tweakAnswers: 'Змінити відповіді',
      retakeQuiz: 'Пройти ще раз',
      matchReason: 'Підходить за вашим вибором',
      whyMatch: 'Рекомендовані аромати за вашим профілем',
      matchedAccords: 'Співпадіння',
    },
    page: {
      notFound: 'Сторінку не знайдено',
    },
    catalog: {
      fragranceCatalog: 'Каталог ароматів',
      fragranceCatalogShop: (shop: string) => `Каталог ароматів — ${shop}`,
      fromPrice: 'від',
      perNight: '/ ніч',
      book: 'Забронювати',
      details: 'Характеристики',
      title: 'Каталог',
      search: 'Пошук товарів...',
      all: 'Всі',
      allStores: 'Всі магазини',
      empty: 'Товарів не знайдено',
      categoriesTitle: 'Категорії',
      loading: 'Завантаження...',
      wishlist: 'Бажання',
      mto: 'Під замовлення',
      addToCart: 'У кошик',
      adding: '...',
      outOfStock: 'Немає',
      addFail: 'Не вдалося додати в кошик. Спробуйте ще раз.',
      filterBtn: 'Фільтр',
      resultCount: (count: number) => `${count} товар${count === 1 ? '' : count >= 2 && count <= 4 ? 'и' : 'ів'}`,
      filters: {
        title: 'Фільтри',
        legend: 'Торкніться: показати → приховати → скинути',
        selected: 'Обрано',
        searchPlaceholder: 'Пошук...',
        noMatches: 'Нічого не знайдено',
        showMore: 'Показати ще',
        showLess: 'Згорнути',
        priceRange: 'Ціна, UAH',
        priceRangeWithCurrency: (currency: string) => `Ціна, ${currency}`,
        priceMin: 'Від',
        priceMax: 'До',
        variant: 'Варіант',
        variantAny: 'Не важливо',
        clear: 'Скинути фільтри',
        apply: 'Показати результати',
      },
    },
    cart: {
      title: 'Кошик',
      decrease: 'Зменшити кількість',
      increase: 'Збільшити кількість',
      remove: 'Видалити',
      empty: 'Кошик порожній',
      loading: 'Завантаження...',
      checkout: (uah: number) => `Оформити — ${uah} UAH`,
      clear: 'Очистити кошик',
      total: 'Разом',
      mtoSingle: 'Під замовлення',
      mtoEta: (d: number) => `🕒 Очікуваний термін виготовлення: ~${d} дн.`,
      mtoGeneric: '🕒 Деякі товари під замовлення',
    },
    checkout: {
      goToCatalog: 'Перейти в каталог',
      backToCart: 'Назад до кошика',
      addItems: '+ Додати товари',
      fopIbanTitle: 'Офіційний рахунок ФОП (IBAN)',
      viewFopRequisites: 'Реквізити ФОП',
      fopPaymentInfo: 'Ви зможете скопіювати IBAN та сплатити замовлення у Monobank, Приват24 чи іншому банкінгу одразу або після оформлення.',
      manualPaymentInfo: 'Деталі оплати будуть узгоджені менеджером при підтвердженні замовлення.',
      title: 'Оформлення',
      loading: 'Завантаження...',
      name: "Ім'я",
      contact: 'Номер телефону',
      deliveryType: 'Тип доставки',
      city: 'Місто',
      delivery: 'Доставка / відділення',
      comment: 'Коментар',
      promo: 'Промокод',
      payment: 'Спосіб оплати',
      securePayment: 'Безпечна оплата',
      submit: (uah: number) => `Замовити — ${uah} UAH`,
      submitting: 'Оформлення...',
      emptyCart: 'Кошик порожній',
      deliveryTypes: [
        { value: '', label: 'Не вибрано' },
        { value: 'nova_poshta', label: 'Нова Пошта' },
        { value: 'ukrposhta', label: 'Укрпошта' },
      ] as { value: string; label: string }[],
      errors: {
        name_required: "Введіть ім'я",
        contact_required: 'Введіть номер телефону',
        city_required: 'Введіть місто',
        delivery_required: 'Введіть відділення або адресу',
        contact_invalid: 'Введіть коректний номер телефону (наприклад: +380501234567)',
        promo_invalid: 'Промокод недійсний або закінчився',
      },
      applyPromo: 'Застосувати',
      promoApplied: 'Промокод застосовано',
      discount: 'Знижка',
    },
    orders: {
      title: 'Мої замовлення',
      loading: 'Завантаження...',
      empty: 'Замовлень ще немає',
      paid: 'Оплачено',
      unpaid: 'Очікує оплати',
      payOnline: 'Оплатити онлайн',
      payOnlineAmount: (amount: number) => `💳 Оплатити онлайн (${amount} UAH)`,
      paying: 'Перехід до оплати...',
      payFailed: 'Не вдалося створити платіж. Спробуйте пізніше.',
      codNote: '📦 Оплата при отриманні (післяплата)',
      total: 'Разом',
      reorder: '🔄 Замовити ще',
      reordering: '...',
      reorderFail: '❌ Недоступно',
      delete: 'Видалити',
      tracking: 'ТТН',
      deliveryStatus: 'Статус доставки',
      deliveryEstimated: 'Орієнтовна доставка',
      deliveryInTransit: 'В дорозі',
      deliveryArrived: 'Прибуло у відділення',
      deliveryReceived: 'Отримано',
      trackNovaPoshta: 'Відстежити на Новій Пошті',
      trackUkrposhta: 'Відстежити на Укрпошті',
      copy: 'Копіювати',
      copied: 'Скопійовано',
      deleteConfirm: (id: number) =>
        `Видалити заявку #${id}? Це можливо лише поки магазин не прийняв її в обробку.`,
      deleteSeenError:
        'Магазин вже прийняв замовлення в обробку — зверніться до нас для скасування.',
      status: {
        new: 'Нове',
        seen: 'В обробці',
        shipped: 'Відправлено',
        done: 'Виконано',
        cancelled: 'Скасовано',
        refunded: 'Повернено',
      },
      changePayment: 'Змінити спосіб оплати',
      paymentMethod: 'Спосіб оплати',
      paymentMethodUpdated: 'Спосіб оплати змінено',
      buyAgain: 'Купити знову',
      addMore: 'Додати в кошик',
      itemAddedToCart: 'Товар додано в кошик',
      orderSupport: 'Підтримка щодо замовлення',
      copyOrderDetails: 'Скопіювати деталі',
      orderDetailsCopied: 'Деталі замовлення скопійовано',
      timeline: {
        new: 'Прийнято',
        seen: 'В обробці',
        shipped: 'Відправлено',
        done: 'Отримано',
      },
      paymentMethods: {
        liqpay: 'LiqPay (Картка / Apple Pay / Google Pay)',
        monopay: 'Monobank (MonoPay / Картка)',
        stripe: 'Stripe (Apple Pay / Картка / BLIK)',
        sandbox: 'Тестова оплата (Sandbox)',
        manual: 'За реквізитами (IBAN / ФОП)',
        cod: 'Післяплата (при отриманні)',
        telegram: 'Telegram Stars',
        pay_on_site: 'Оплата на місці',
      },
      sandboxPayment: {
        title: 'Тестова оплата (Sandbox)',
        subtitle: 'Симулятор платіжного шлюзу для тестування',
        orderNumber: 'Замовлення #',
        amount: 'Сума до сплати',
        selectMethod: 'Оберіть тестовий метод оплати',
        card: 'Тестова картка (Visa / Mastercard)',
        applePay: 'Apple Pay (Симуляція)',
        blik: 'BLIK (Тестовий код: 123456 / 777123)',
        cardHint: 'Використовується віртуальна тестова картка 4242 4242 4242 4242',
        blikHint: 'Для тестування BLIK підійде будь-який 6-значний код (наприклад, 123456 або 777123)',
        simulateSuccess: '✅ Підтвердити тестову оплату (Success)',
        simulateFail: '❌ Симулювати відхилення (Decline)',
        processing: 'Обробка тестового платежу...',
        successTitle: 'Оплату успішно здійснено!',
        successText: 'Замовлення позначено як оплачене, запущено фіскалізацію та сповіщення.',
        failedTitle: 'Оплату відхилено',
        failedText: 'Симулятор відхилив тестову транзакцію. Ви можете спробувати ще раз.',
        backToOrders: 'Перейти до моїх замовлень',
        tryAgain: 'Спробувати знову',
      },
    },
    product: {
      fastDeliveryTitle: 'Швидка доставка по Україні',
      fastDeliveryText: 'Нова Пошта (відділення, поштомати, кур\'єр), Укрпошта. Відправка 1-2 дні.',
      officialFopTitle: 'Офіційна оплата за реквізитами ФОП (IBAN)',
      officialFopText: 'Оплата на офіційний рахунок IBAN (Monobank, Приват24), онлайн картою або при отриманні.',
      kitContents: 'Склад набору:',
      spraysEstimate: (sprays: number) => `≈ ${sprays} розп.`,
      free: 'Безкоштовно',
      back: 'Назад до каталогу',
      notFound: 'Товар не знайдено',
      addToCart: 'Додати в кошик',
      adding: 'Додаємо...',
      added: 'У кошику',
      madeToOrder: 'Виготовляємо під замовлення',
      watchVideo: 'Дивитися відео',
      share: 'Поділитися',
      addToWishlist: 'В обране',
      inWishlist: 'В обраному',
      description: 'Опис',
      attributes: 'Атрибути',
      filterByAttribute: 'Показати схожі',
      outOfStock: 'Немає в наявності',
      shareSuccess: 'Посилання скопійовано',
      shareError: 'Не вдалося поділитися',
      addFail: 'Не вдалося додати в кошик. Спробуйте ще раз.',
      relatedTitle: 'Вам також може сподобатись',
      noReviewsYet: 'ще немає відгуків',
      reviewsCount: (n: number) => `${n} ${n === 1 ? 'відгук' : n < 5 ? 'відгуки' : 'відгуків'}`,
      writeReview: 'Написати відгук',
      reviewCommentPlaceholder: 'Ваш відгук (необов’язково)',
      reviewSubmit: 'Надіслати',
      reviewSubmitting: 'Надсилаємо...',
      reviewCancel: 'Скасувати',
      reviewSubmitted: 'Дякуємо! Відгук з’явиться після перевірки модератором.',
      reviewSubmitFailed: 'Не вдалося надіслати відгук. Спробуйте ще раз.',
    },
    wishlist: {
      title: 'Список бажань',
      loading: 'Завантаження...',
      empty: 'Поки що немає збережених товарів',
      clear: 'Очистити',
      addToCart: 'У кошик',
      adding: '...',
      outOfStock: 'Немає',
      openCatalog: 'Перейти в каталог',
      addFail: 'Не вдалося додати в кошик. Спробуйте ще раз.',
    },
    auctions: {
      title: 'Аукціони',
      loading: 'Завантаження...',
      empty: 'Активних аукціонів немає',
      disabled: 'Аукціони зараз вимкнені',
      bids: 'ставок',
      ended: 'Завершено',
    },
    auction: {
      back: 'До аукціонів',
      notFound: 'Не знайдено',
      disabled: 'Аукціони зараз вимкнені',
      bids: 'ставок',
      ended: 'Завершено',
      winning: 'Ви лідируєте!',
      recentBids: 'Останні ставки',
      bidder: 'Учасник',
      you: 'Ви',
    },
    services: {
      title: 'Послуги',
      empty: 'Послуг поки немає',
      provider: 'Виконавець',
      date: 'День',
      time: 'Час',
      noSlots: 'На цей день немає вільних слотів',
      notes: 'Коментар до запису',
      add: 'Додати в кошик',
      adding: 'Додається...',
      slotTaken: 'Цей час уже зайнятий. Оберіть інший слот.',
      calendarConflict:
        '⏳ Додано до кошика. Запис потребує підтвердження — у виконавця є інший захід на цей час.',
      min: 'хв',
      back: '← Назад',
    },
    bookings: {
      title: 'Мої записи',
      empty: 'Записів ще немає',
      paid: 'Оплачено',
      unpaid: 'Очікує оплати',
      filters: {
        all: 'Усі',
        active: 'Активні',
        past: 'Минулі',
        cancelled: 'Скасовані',
      },
      anyDay: 'Будь-який день',
      service: 'Послуга',
      provider: 'Виконавець',
      contact: 'Контакт',
      created: 'Створено',
      notes: 'Коментар',
      addToCalendar: 'Додати в календар',
      cancel: 'Скасувати',
      cancelling: '...',
      confirmCancel: (id: number) => `Скасувати запис #${id}?`,
      calendarPending: '⚡ Очікує підтвердження через конфлікт у календарі',
      cancellationReason: 'Причина скасування',
      status: {
        pending: 'Очікує',
        confirmed: 'Підтверджено',
        cancelled: 'Скасовано',
        done: 'Виконано',
        no_show: 'Не прийшов',
      },
    },
    profile: {
      title: 'Профіль',
      subtitle: 'Керуйте своїми даними та показуйте тільки потрібні розділи',
      error: 'Помилка завантаження',
      editProfile: 'Редагувати профіль',
      editProfileHint: "Ім'я, контакти, мова та збережена доставка",
      myOrders: 'Мої замовлення',
      myOrdersHint: 'Історія, повторне замовлення та видалення',
      myBookings: 'Мої записи',
      myBookingsHint: 'Активні записи та скасування',
      createStore: 'Стати продавцем',
      createStoreHint: 'Створіть свій магазин і керуйте товарами окремо',
      becomingSeller: 'Відкриваємо доступ...',
      openAdmin: 'Відкрити адмінку',
      openAdminHint: 'Окремий застосунок для продавця або менеджера',
      login: 'Увійти',
      loginHint: 'Увійдіть, щоб бачити замовлення, бронювання та збережені дані',
      logout: 'Вийти',
      logoutHint: 'Завершити поточну сесію',
      loggingOut: 'Виходимо...',
      guestName: 'Гість',
      guestContact: 'Увійдіть, щоб керувати профілем',
      nameFallback: 'Без імені',
      noContact: 'Додайте телефон або email',
      noDelivery: 'Доставка ще не налаштована',
      interfaceLanguage: 'Мова інтерфейсу',
      languageLabels: { uk: 'Українська', en: 'English', ru: 'Русский' } as Record<string, string>,
      deliveryLabels: { nova_poshta: 'Нова Пошта', ukrposhta: 'Укрпошта' } as Record<
        string,
        string
      >,
      infoTitle: 'Інформація',
      myActivity: 'Моя активність',
      myWishlist: 'Список бажань',
      myWishlistHint: 'Збережені товари та швидкий доступ',
      perfumeProfile: 'Ольфакторний профіль',
      perfumeProfileHint: 'Ваш персональний парфумерний архетип',
      perfumeQuizCta: 'Підібрати свій аромат',
      perfumeQuizCtaHint: 'Пройдіть тест для персонального підбору парфумів',
      guidesTitle: 'Корисні матеріали',
      perfumeGuides: 'Парфумерний гід та статті',
      perfumeGuidesHint: '7 гайдів про нішеві аромати, деканти та стійкість',
      articlesAndGuides: 'Статті та інструкції',
      articlesAndGuidesHint: (count: number) =>
        count > 0 ? `${count} корисних матеріалів та інструкцій` : 'Корисні матеріали та інструкції',
      helpAndRules: 'Сервіс та правила',
      supportTelegram: 'Підтримка в Telegram',
      supportTelegramHint: 'Написати менеджеру магазину',
      storeInfoAndRules: 'Про магазин та умови',
      storeInfoAndRulesHint: 'Доставка, оплата, умови конфіденційності',
      accountSettings: 'Налаштування',
      referralTitle: 'Запросіть друга',
      referralHint: (percent: number) =>
        `Поділіться кодом — новий покупець отримає ${percent}% знижки, а ви — бонус на наступне замовлення.`,
      referralCopy: 'Скопіювати код',
      referralShare: 'Поділитися',
      referralCopied: 'Код скопійовано',
      referralShareText: (code: string, percent: number, shopName: string) =>
        `Знижка ${percent}% у ${shopName || 'нашому магазині'} за промокодом ${code}!`,
    },
    profileEdit: {
      title: 'Редагувати профіль',
      back: 'Назад до профілю',
      name: "Ім'я",
      email: 'Email',
      phone: 'Телефон',
      delivery: 'Збережена доставка',
      deliveryType: 'Тип доставки',
      city: 'Місто',
      warehouse: 'Відділення',
      save: 'Зберегти',
      saving: 'Збереження...',
      saved: '✅ Збережено',
      logout: 'Вийти',
      language: 'Мова інтерфейсу',
      languageUk: '🇺🇦 Українська',
      languageEn: '🇬🇧 English',
      error: 'Помилка завантаження',
      emailHint: 'Для входу через email та отримання чеків',
      phoneHint: "Для зв'язку щодо замовлень і доставки",
      deliveryHint: 'Буде підставлено автоматично при оформленні замовлення',
      phonePlaceholder: '+380...',
      cityPlaceholder: 'напр. Київ',
      warehousePlaceholder: 'напр. Відділення №5',
      deliveryTypes: [
        { value: '', label: 'Не вибрано' },
        { value: 'nova_poshta', label: 'Нова Пошта' },
        { value: 'ukrposhta', label: 'Укрпошта' },
      ] as { value: string; label: string }[],
    },
    login: {
      title: 'Увійти',
      loading: 'Завантаження...',
      subtitle: 'Оберіть зручний спосіб входу. Кожен варіант веде до того самого акаунта.',
      telegramTitle: 'Telegram',
      telegramWidget: 'Увійти через Telegram',
      telegramHint: 'Швидкий вхід через Telegram-акаунт просто у браузері',
      googleTitle: 'Google',
      google: 'Увійти через Google',
      googleHint: 'Швидкий вхід через ваш Google-акаунт',
      emailTitle: 'Email',
      emailHint: 'Отримаєте magic link на пошту без пароля',
      emailPlaceholder: 'ваш@email.com',
      emailBtn: 'Надіслати посилання',
      emailSending: 'Надсилання...',
      emailSent: 'Посилання надіслано — перевірте пошту.',
      emailResend: 'Надіслати ще раз',
      emailError: 'Помилка. Спробуйте ще раз.',
      openTelegram: 'Відкрити магазин у Telegram',
      openTelegramHint: 'Окремий перехід у Telegram, не частина browser-login',
      noProviders: 'Вхід тимчасово недоступний. Зверніться до адміністратора.',
      guest: 'Продовжити як гість',
      guestHint: 'Можна переглядати каталог без профілю, а увійти в акаунт пізніше.',
      guestError: 'Не вдалося відкрити гостьовий доступ.',
    },
    novaPoshta: {
      cityPlaceholder: 'Почніть вводити місто',
      cityHint: 'Оберіть місто зі списку, щоб побачити відділення',
      warehousePlaceholder: 'Почніть вводити номер або адресу відділення',
      warehouseHint: 'Шукайте відділення за номером або текстом адреси',
      loading: 'Завантаження...',
      notConfigured: 'Пошук Нової Пошти недоступний — можна ввести вручну.',
      noCities: 'Місто не знайдено',
      noWarehouses: 'Відділень не знайдено',
      selectedCity: 'Обране місто',
      selectedWarehouse: 'Обране відділення',
      changeCity: 'Змінити місто',
      changeWarehouse: 'Змінити відділення',
    },
    ukrposhta: {
      byIndexTab: 'За індексом',
      byCityTab: 'За містом',
      indexPlaceholder: '5-значний індекс (напр. 01001)',
      indexHint: 'Введіть 5 цифр поштового індексу',
      cityPlaceholder: 'Почніть вводити місто',
      cityHint: 'Оберіть місто зі списку',
      officePlaceholder: 'Оберіть відділення Укрпошти',
      officeHint: 'Шукайте за індексом або адресою',
      loading: 'Завантаження...',
      notConfigured: 'Пошук Укрпошти недоступний — можна ввести вручну.',
      noOffices: 'Відділень не знайдено',
      noCities: 'Місто не знайдено',
      selectedCity: 'Обране місто',
      selectedOffice: 'Обране відділення',
      changeCity: 'Змінити місто',
      changeOffice: 'Змінити відділення',
    },
    admin: {

      ordersCount: (count: number) => `Замовлення (${count})`,
      noOrdersFiltered: 'Немає замовлень за обраними фільтрами.',
      orderCardTitle: (id: number, date: string) => `Замовлення #${id} · ${date}`,
      client: 'Клієнт',
      contact: 'Контакт',
      city: 'Місто',
      delivery: 'Доставка',
      items: 'Товари',
      comment: 'Коментар',
      changeStatus: 'Змінити статус',
      markUnpaid: 'Позначити як неоплачене',
      archiveOrder: 'В архів',
      unarchiveOrder: 'Повернути з архіву',
      statusUpdated: 'Статус оновлено',
      paymentUpdated: 'Статус оплати оновлено',
      archiveUpdated: 'Замовлення оновлено',
      trackingNumber: 'ТТН / Трек-номер',
      setTracking: 'Зберегти ТТН',
      fiscalizeAction: 'Фіскалізувати (Checkbox)',
      fiscalizeSuccess: 'Чек успішно фіскалізовано!',
      fiscalizeError: 'Помилка фіскалізації чека',
      fiscalReceipt: 'Фіскальний чек',
      questionsNav: 'Питання',
      questionsTitle: 'Питання клієнтів',
      questionsPending: 'Очікують відповіді',
      questionsAnswered: 'З відповіддю',
      noQuestionsFiltered: 'Немає питань за обраними фільтрами.',
      questionFrom: (name: string, date: string) => `Від: ${name} · ${date}`,
      questionProduct: 'Товар:',
      answerPlaceholder: 'Введіть відповідь клієнту...',
      answerSent: 'Відповідь успішно надіслано клієнту в Telegram!',
      noReviews: 'Немає відгуків для модерації.',
      reviewApproved: 'Відгук схвалено та опубліковано на сайті!',
      reviewRejected: 'Відгук відхилено',
      reviewDeleteConfirm: 'Видалити цей відгук?',
      reviewDeleted: 'Відгук видалено',
      rating: 'Оцінка',
      reviewAuthor: 'Автор',
      reviewComment: 'Текст відгуку',
      reviewDate: 'Дата',
      importExportNav: 'Імпорт / Експорт',
      importExportTitle: 'Імпорт та Експорт даних',
      importExportText: 'Масове вивантаження та завантаження каталогу товарів через CSV/JSON.',
      exportProductsCsv: 'Експорт товарів у CSV',
      importProductsCsv: 'Імпорт товарів з CSV',
      importProductsHint: 'Завантажте CSV-файл зі структурою: name_uk, price, category, ...',
      chooseCsvFile: 'Обрати CSV файл',
      startImport: 'Почати імпорт',
      importing: 'Імпорт товарів...',
      importSuccess: (count: number) => `Успішно імпортовано ${count} товарів!`,
      importError: 'Помилка при імпорті файлу',
      ordersStatusFilter: 'Фільтр за статусом',
      ordersDateRange: 'Період',
      customerProfile: 'Профіль клієнта',
      orderTimeline: 'Історія замовлення',
      paymentMethod: 'Метод оплати',
      deliveryAddress: 'Адреса доставки',
      fiscalCheckUrl: 'Посилання на фіскальний чек',
      sendTelegramNotification: 'Надіслати сповіщення в Telegram',
      notificationSent: 'Сповіщення надіслано клієнту',
      notificationFailed: 'Не вдалося надіслати сповіщення',

      badge: 'Адмінка',
      title: 'Керування магазином',
      backToShop: 'Назад у магазин',
      dashboard: 'Огляд',
      storesNav: 'Магазини',
      lodgingNav: 'Номери',
      products: 'Товари',
      bannersNav: 'Баннери',
      bannersTitle: 'Баннери головної сторінки',
      bannersSubtitle: 'Керування слайдером баннерів на головній сторінці магазину.',
      addBannerAction: 'Додати баннер',
      closeForm: 'Закрити форму',
      createBannerTitle: '➕ Створення нового баннера',
      editBannerTitle: (id: number) => `Редагування баннера #${id}`,
      bannerImageUrl: 'URL картинки',
      bannerImageUrlPlaceholder: '/shared-assets/banners/banner-name.png або https://...',
      readyPresets: 'Готові шаблони:',
      bannerAltText: 'Опис / Заголовок',
      bannerAltPlaceholder: 'Наприклад: PANA DORA — Весняна колекція',
      bannerHref: 'Посилання (href)',
      bannerHrefPlaceholder: '/catalog або /catalog?category=perfume',
      bannerPreview: 'Попередній перегляд:',
      bannerActiveLabel: 'Показувати в каруселі (Активний)',
      bannerActiveStatus: 'Активний',
      bannerInactiveStatus: 'Вимкнутий',
      createBannerSubmit: 'Створити баннер',
      saveBannerChanges: 'Зберегти зміни',
      bannersListTitle: (count: number) => `Список баннерів (${count})`,
      loading: 'Завантаження...',
      loadingBanners: 'Завантаження...',
      noBanners: 'Баннерів поки немає. Натисніть «Додати баннер» вище.',
      bannerAdded: 'Баннер успішно додано!',
      bannerSaved: 'Баннер успішно оновлено!',
      bannerDeleted: 'Баннер видалено!',
      deleteBannerConfirm: 'Видалити цей баннер?',
      validationBannerUrlRequired: 'Потрібно вказати URL картинки баннера',
      moveUp: 'Перемістити вгору',
      moveDown: 'Перемістити вниз',
      enableBanner: 'Увімкнути',
      disableBanner: 'Вимкнути',
      noBannerTitle: 'Без назви',
      delete: 'Видалити',
      orders: 'Замовлення',
      questions: 'Питання',
      services: 'Послуги',
      aiGuideNav: 'ШІ Помічник / AI Guide',
      staffNav: 'Персонал',
      navGroupOverview: 'Огляд',
      navGroupCatalog: 'Каталог',
      navGroupSales: 'Продажі',
      navGroupAdmin: 'Адміністрування',
      scopeTitle: 'Рівень доступу',
      scopeHint: 'Перший етап навмисно простий: окремий застосунок для щоденної роботи продавця або менеджера.',
      welcome: 'Реакт-адмінка для щоденних операцій',
      dashboardTitle: 'Операційна панель магазину',
      dashboardText: 'Керуйте магазинами, товарами й замовленнями з одного веб-екрана. Доступ і дані вже обмежені роллю та привʼязаними магазинами.',
      role: 'Роль',
      stores: 'Магазини',
      phase: 'Етап',
      phaseValue: 'Backoffice rollout',
      scopedStores: 'Доступні магазини',
      newOrders: 'Нові замовлення',
      pendingQuestions: 'Питання',
      recentOrders: 'Останні замовлення',
      recentOrdersText: 'Найсвіжіші замовлення у вашому доступі.',
      openOrders: 'Відкрити замовлення',
      openQuestions: 'Відкрити питання',
      stockSnapshot: 'Стан товарів',
      attention: 'Потребує уваги',
      attentionText: (unpaid: number, questions: number) =>
        `${unpaid} неоплачених замовлень · ${questions} питань без відповіді`,
      allStores: 'Усі доступні магазини',
      productsText: 'Список товарів уже відфільтрований за роллю та магазинами.',
      productsCrudText:
        'Тут можна безпечно створювати, редагувати й видаляти товари, а також керувати опціями, фото та YouTube-посиланням без зайвого глобального state.',
      storeFilter: 'Магазин',
      prevPage: 'Назад',
      nextPage: 'Далі',
      pageRange: (from: number, to: number, total: number) => `${from}-${to} із ${total}`,
      backToProducts: 'До списку товарів',
      currentScope: 'Поточний обсяг',
      currentCategory: 'Поточна категорія',
      loadingProducts: 'Завантаження товарів...',
      loadingProductEditor: 'Завантаження редактора товару...',
      loadingServices: 'Завантаження послуг...',
      loadingOrders: 'Завантаження замовлень...',
      madeToOrder: 'Під замовлення',
      stockItem: 'Складський товар',
      inStock: 'В наявності',
      outOfStock: 'Немає в наявності',
      activeService: 'Активна',
      inactiveService: 'Прихована',
      minutes: 'хв',
      daysShort: 'дн.',
      pcsShort: 'шт',
      editLater: 'Редагування буде в наступній фазі',
      noProducts: 'Поки що немає доступних товарів',
      noProductsText: 'Якщо ви очікували товари тут, перевіримо привʼязку продавця або менеджера до магазину.',
      searchProductPlaceholder: 'Пошук за назвою або ID...',
      filterAll: 'Всі',
      categoryFilter: 'Категорія',
      allCategories: 'Усі категорії',
      errorLoadingProducts: 'Не вдалося завантажити товари.',
      noServices: 'Поки що немає доступних послуг',
      noServicesText: 'Тут зʼявляться послуги з доступних магазинів, коли ми доберемо їхній CRUD.',
      errorLoadingServices: 'Не вдалося завантажити послуги.',
      servicesText: 'Переглядайте послуги у доступних магазинах. Повний CRUD для послуг буде в наступній фазі.',
      servicesDisabledText: 'Бронювання послуг вимкнено в глобальних налаштуваннях.',
      ordersText: 'Обробляйте нові замовлення, оплату, доставку, фіскалізацію та архів без повернення в Telegram-меню.',
      searchOrdersPlaceholder: 'Пошук (№ замовлення, клієнт, телефон, ТТН)...',
      exportCsv: 'Експорт CSV',
      exportingCsv: 'Експорт...',
      copied: 'Скопійовано!',
      copyPhone: 'Скопіювати телефон',
      copyAddress: 'Скопіювати адресу',
      orderStatus: 'Статус',
      allStatuses: 'Усі статуси',
      payment: 'Оплата',
      allPayments: 'Усі оплати',
      paid: 'Оплачено',
      unpaid: 'Очікує оплати',
      showArchive: 'Архів',
      noOrders: 'Замовлень не знайдено',
      noOrdersText: 'Змініть фільтри або перевірте доступ до магазинів.',
      orderTotal: 'Сума',
      orderUpdated: 'Замовлення оновлено',
      orderUpdateFailed: 'Не вдалося оновити замовлення',
      trackingSaved: 'ТТН збережено',
      orderPaidMarked: 'Оплату позначено',
      orderArchived: 'Замовлення перенесено в архів',
      orderRestored: 'Замовлення повернено з архіву',
      orderDeletedForever: 'Замовлення видалено назавжди',
      refiscalizeQueued: 'Повторну фіскалізацію запущено',
      npCreateWaybill: 'Створити накладну НП',
      npCityPlaceholder: 'Місто отримувача...',
      npWarehousePlaceholder: 'Відділення...',
      npChangeCity: 'Змінити місто',
      npChangeWarehouse: 'Змінити відділення',
      npRecipientName: "Ім'я отримувача",
      npRecipientPhone: 'Телефон отримувача',
      npWeightKg: 'Вага, кг',
      npSubmit: 'Створити',
      npCancel: 'Скасувати',
      npCreateFailed: 'Не вдалося створити накладну',
      npWaybillCreated: 'Накладну створено',
      tracking: 'ТТН',
      saveTracking: 'Зберегти ТТН',
      markPaid: 'Оплачено',
      refiscalize: 'Фіскалізувати',
      archive: 'Архів',
      restore: 'Відновити',
      deleteForever: 'Назавжди',
      hardDeleteConfirm: (id: number) => `Назавжди видалити замовлення #${id}?`,
      receipt: 'Чек',
      noReceipt: 'Без чека',
      status: {
        new: 'Нове',
        seen: 'В обробці',
        shipped: 'Відправлено',
        done: 'Виконано',
        cancelled: 'Скасовано',
        refunded: 'Повернено',
      },
      viewModeList: 'Список',
      viewModeReview: "Рев'ю замовлень",
      orderReviewTitle: 'Покрокова обробка замовлень',
      orderReviewCounter: (current: number, total: number) => `Замовлення ${current} із ${total}`,
      orderReviewNext: 'Наступне',
      orderReviewPrev: 'Попереднє',
      orderReviewRecommendedAction: 'Рекомендована дія',
      orderReviewConfirmStatus: (id: number, status: string) => `Змінити статус замовлення #${id} на «${status}»?`,
      orderReviewDeliveryDetails: 'Деталі доставки',
      orderReviewCity: 'Місто',
      orderReviewWarehouse: 'Відділення / адреса',
      orderReviewCustomer: 'Клієнт',
      orderReviewPhone: 'Телефон',
      orderReviewComment: 'Коментар клієнта',
      orderReviewItems: 'Склад замовлення',
      orderReviewCopyRequisites: 'Скопіювати реквізити',
      orderReviewRequisitesCopied: 'Реквізити скопійовано',
      orderReviewActionConfirmOrder: 'Підтвердити замовлення',
      orderReviewActionMarkShipped: 'Позначити відправленим',
      orderReviewActionMarkDone: 'Позначити виконаним',
      orderReviewQueueAll: 'Усі замовлення',
      orderReviewQueuePending: 'Потребують обробки',
      orderReviewQueueProcessing: 'В обробці',
      statusConfirmPrompt: (id: number, status: string) => `Змінити статус замовлення #${id} на «${status}»?`,
      refundOrder: 'Повернути кошти',
      refundReasonPrompt: 'Причина повернення (необов’язково):',
      refundSuccess: 'Замовлення позначено як повернене',
      refundFailed: 'Не вдалося оформити повернення',
      cancelOrder: 'Скасувати замовлення',
      questionsText: 'Відповідайте на питання клієнтів і одразу зберігайте відповідь у FAQ для наступних звернень.',
      pendingQuestionsCount: (count: number) => `Питання без відповіді: ${count}`,
      loadingQuestions: 'Завантаження питань...',
      noQuestions: 'Немає питань без відповіді',
      noQuestionsText: 'Коли клієнт поставить питання без готової відповіді, воно зʼявиться тут.',
      userId: 'Користувач',
      answerQuestion: 'Відповідь клієнту',
      answerText: 'Текст відповіді',
      sendAnswer: 'Надіслати відповідь',
      selectQuestion: 'Оберіть питання з черги',
      questionAnswered: 'Відповідь збережено у FAQ',
      questionAnswerFailed: 'Не вдалося зберегти відповідь',
      answerRequired: 'Напишіть відповідь',
      storesText: 'Створюйте свій магазин, оновлюйте картку та додавайте базові категорії без окремого важкого бек-офісу.',
      storeEditorTitle: 'Картка магазину',
      storeEditorText: 'Фото, назва, slug і контакти редагуються окремою компактною карткою.',
      createStoreTitle: 'Новий магазин',
      createStoreText: 'Спочатку зберігаємо базову картку магазину, а далі вже додаємо товари й категорії.',
      createStoreAction: 'Створити магазин',
      cancel: 'Скасувати',
      createAnotherStore: 'Ще один магазин',
      createAnotherStoreText: 'Відкрийте окрему картку для нового магазину, якщо глобально дозволено мульти-магазинність.',
      storeSaved: 'Магазин збережено',
      storeCreated: 'Магазин створено',
      storeActive: 'Активний',
      storeInactive: 'Вимкнено',
      storeActivate: 'Увімкнути магазин',
      storeDeactivate: 'Вимкнути магазин',
      storeToggled: 'Стан магазину оновлено',
      staffTitle: 'Персонал і продавці',
      staffText: 'Керування адміністраторами, менеджерами та продавцями — тільки для суперадміна.',
      staffTab: 'Персонал',
      sellersTab: 'Продавці',
      addStaffTitle: 'Додати співробітника',
      staffUserId: 'Telegram user_id',
      staffRole: 'Роль',
      staffName: "Ім'я (для сповіщень)",
      staffEmail: 'Email (для сповіщень)',
      addStaffAction: 'Додати',
      staffAdded: 'Співробітника додано',
      removeStaffConfirm: 'Прибрати цього співробітника?',
      staffRemoved: 'Співробітника прибрано',
      noStaff: 'Ще немає доданих співробітників.',
      noSellers: 'Ще немає продавців.',
      sellerApprove: 'Схвалити',
      sellerBlock: 'Заблокувати',
      sellerUnblock: 'Розблокувати',
      sellerApproved: 'Продавця схвалено',
      sellerBlocked: 'Продавця заблоковано',
      sellerUnblocked: 'Продавця розблоковано',
      sellerPendingBadge: 'Очікує підтвердження',
      sellerBlockedBadge: 'Заблокований',
      sellerApprovedBadge: 'Активний',
      roleManager: 'Менеджер (manager)',
      roleSuperadmin: 'Суперадмін (superadmin)',
      roleSeller: 'Продавець (seller)',
      validationStaffUserIdRequired: "Вкажіть коректний Telegram user_id",
      settingsNav: 'Налаштування',
      settingsTitle: 'Налаштування магазину',
      settingsText: 'Технічні та фінансові налаштування — тільки для суперадміна.',
      settingsSaved: 'Налаштування збережено',
      settingsSectionGeneral: 'Загальні',
      maintenanceMode: 'Технічні роботи',
      maintenanceModeText: 'Коли увімкнено, звичайні клієнти в Telegram-боті бачать повідомлення нижче замість магазину.',
      maintenanceMessage: 'Повідомлення про технічні роботи',
      sellerRegistrationEnabled: 'Дозволити самостійну реєстрацію продавців',
      minOrderUah: 'Мінімальна сума замовлення, UAH',
      priceRounding: 'Округлення ціни (UAH)',
      priceRoundingOff: 'Без округлення',
      phonePlaceholderLabel: 'Приклад телефону для клієнтів (Phone Placeholder)',
      phonePlaceholderText: 'Приклад формату номеру телефону в полях вводу для клієнтів незалежно від країни.',
      settingsSectionPayments: 'Оплата',
      bankRecipient: "Отримувач (для ручної оплати)",
      bankCard: 'Номер картки',
      bankIban: 'IBAN',
      bankExtraInfo: 'Додаткова інформація для оплати',
      lodgingDepositPercent: 'Передоплата за бронювання (%)',
      customPaymentName: 'Назва додаткового способу оплати',
      customPaymentDescription: 'Реквізити / інструкція (наприклад IBAN)',
      paymentMethodsEnabled: 'Способи оплати на checkout',
      settingsSectionAuth: 'Вхід на сайт',
      authProvidersEnabled: 'Способи входу на окремому сайті (поза Telegram)',
      aiAgentTokenSectionTitle: '🔑 Доступ для ШІ-Агента (AI Agent Access)',
      aiAgentTokenSectionText: 'Згенеруйте короткоживучий або одноразовий API-токен для передачі ШІ-агенту (Antigravity, Claude, Gemini). Агент виконуватиме виклики API для додавання товарів, завантаження фотографій чи налаштувань від вашого імені.',
      aiAgentTokenTtl: 'Час дії токена (TTL)',
      aiAgentTokenTtl15m: '15 хвилин',
      aiAgentTokenTtl1h: '1 година (60 хв)',
      aiAgentTokenTtl6h: '6 годин',
      aiAgentTokenTtl24h: '24 години (1 день)',
      aiAgentTokenTaskLabel: "Назва задачі / примітка (необов'язково)",
      aiAgentTokenTaskPlaceholder: 'напр. Додати новий парфум Creed Aventus',
      aiAgentTokenSingleUse: 'Одноразовий токен (single-use) — токен згорить одразу після першого використання',
      aiAgentTokenGenerate: '🔑 Згенерувати токен для AI',
      aiAgentTokenGenerating: 'Генерація...',
      aiAgentTokenReady: 'Ваш токен для ШІ-агента готовий!',
      aiAgentTokenSingleUseBadge: '⚡ Одноразовий',
      aiAgentTokenValidTtl: '⏳ Дійсний {ttl} хв',
      aiAgentTokenCopyPrompt: '📋 Скопіювати промпт для ШІ в 1 клік',
      aiAgentTokenCopied: 'Скопійовано! ✅',
      aiAgentTokenError: 'Помилка випуску токена',
      settingsSectionBackup: 'Резервні копії',
      autoBackupHour: 'Година автобекапу (0-23, -1 = вимкнено)',
      gdriveEnabled: 'Вивантажувати бекапи в Google Drive',
      gdriveFolderId: 'ID папки Google Drive',
      gdriveKeepBackups: 'Скільки бекапів зберігати',
      gdriveUploadSettings: 'Вивантажувати налаштування',
      gdriveUploadPhotos: 'Вивантажувати фото',
      emailBackupEnabled: 'Надсилати резервну копію на Email',
      emailBackupEnabledText: 'Автоматична доставка бази даних JSONL на вашу поштову скриньку',
      emailBackupAddress: 'Email для отримання бекапів',
      emailBackupAddressPlaceholder: 'admin@example.com',
      emailBackupAddressHint: 'Залиште порожнім, щоб надсилати на основний email замовлень',
      emailBackupFrequency: 'Періодичність відправки на пошту',
      emailBackupFreq1Day: 'Щодня',
      emailBackupFreq2Days: 'Кожні 2 дні',
      emailBackupFreq3Days: 'Кожні 3 дні',
      emailBackupFreq7Days: 'Щотижня (кожні 7 днів)',
      emailBackupFreq14Days: 'Кожні 2 тижні',
      emailBackupFreq30Days: 'Щомісяця (кожні 30 днів)',
      emailBackupFrequencyHint: 'Бекап відправлятиметься не частіше вказаного інтервалу у встановлену годину автобекапу',
      emailBackupLastSent: 'Останній бекап на пошту надіслано',
      downloadBackupNow: 'Завантажити бекап БД зараз',
      settingsSectionSeo: 'SEO',
      googleSiteVerification: 'Google Search Console: код підтвердження',
      googleSiteVerificationText:
        'Вставте значення content з тегу підтвердження Google Search Console (метод "HTML-тег"): Search Console → Додати ресурс → домен сайту → метод HTML-тег → скопіюйте лише значення content, без усього тегу. Після збереження тег автоматично додається на всі сторінки сайту.',
      ga4MeasurementId: 'Google Analytics: Measurement ID',
      ga4MeasurementIdText:
        'ID виду G-XXXXXXXXXX з Google Analytics 4. Трекінг вантажиться тільки після згоди відвідувача в банері cookie-згоди — порожнє значення повністю вимикає і банер, і трекінг.',
      metaPixelId: 'Meta / Facebook Pixel ID',
      metaPixelIdText: 'ID пікселя Meta/Facebook для відстеження конверсій та ретаргетингу в Instagram і Facebook.',
      validationDepositPercentInvalid: 'Відсоток передоплати має бути від 0 до 100',
      validationBackupHourInvalid: 'Година бекапу має бути від -1 до 23',
      dismiss: 'Закрити',
      settingsSectionMedia: 'Медіа',
      youtubeChannelId: 'ID YouTube-каналу',
      youtubeChannelIdText:
        'Ідентифікатор каналу (починається на "UC..."). Знайти його: відкрийте свій канал на YouTube у браузері → "Про канал" → "Поділитися каналом" → "Скопіювати ID каналу". Після збереження на головній сторінці автоматично з\'явиться карусель останніх відео каналу — оновлюється сама, без ручного додавання нових роликів.',
      settingsSectionEmail: 'Сповіщення та Email (SMTP)',
      smtpStatusTitle: 'Статус SMTP сервера',
      smtpConfiguredBadge: 'SMTP налаштовано та працює',
      smtpNotConfiguredBadge: 'SMTP не налаштовано в .env',
      ordersEmailLabel: 'Email для сповіщень про нові замовлення (Менеджер)',
      ordersEmailPlaceholder: 'orders@mayparfum.com',
      ordersEmailText: 'На цю адресу надсилатиметься копія кожного нового замовлення з переліком товарів та контактами клієнта.',
      customerOrderEmailEnabled: 'Надсилати клієнту лист-підтвердження замовлення на Email',
      customerOrderEmailEnabledText: 'Якщо клієнт вказав email при оформленні замовлення, йому надійде лист з деталями та інструкцією оплати.',
      testEmailTitle: 'Перевірка надсилання Email',
      testEmailPlaceholder: 'Введіть email для перевірки (напр. your@email.com)',
      testEmailSend: 'Надіслати тестовий лист',
      testEmailSending: 'Надсилання...',
      faqNav: 'FAQ',

      faqTitle: 'База знань (FAQ)',
      faqText: 'Питання й відповіді, які бот показує клієнтам напряму, без очікування менеджера.',
      addFaqTitle: 'Нове питання',
      editFaqTitle: 'Редагувати питання',
      faqQuestionUk: 'Питання українською',
      faqQuestionEn: 'Питання англійською',
      faqAnswerUk: 'Відповідь українською',
      faqAnswerEn: 'Відповідь англійською',
      faqKeywords: 'Ключові слова (через кому)',
      addFaqAction: 'Додати',
      saveFaqAction: 'Зберегти',
      faqAdded: 'Питання додано',
      faqSaved: 'Питання оновлено',
      faqRemoved: 'Питання видалено',
      removeFaqConfirm: 'Видалити це питання?',
      noFaq: 'Ще немає питань у базі знань.',
      searchFaqPlaceholder: 'Пошук питань або ключових слів...',
      noFaqFound: 'Нічого не знайдено за вашим запитом.',
      edit: 'Редагувати',
      validationFaqQuestionRequired: 'Вкажіть питання українською',
      validationFaqAnswerRequired: 'Вкажіть відповідь українською',
      analyticsNav: 'Аналітика',
      analyticsTitle: 'Аналітика магазину',
      analyticsText: 'Виручка, замовлення та клієнти — тільки для менеджерів і суперадміна.',
      analyticsToday: 'Сьогодні',
      analyticsWeek: 'За 7 днів',
      analyticsMonth: 'За 30 днів',
      analyticsAllTime: 'За весь час',
      analyticsOrders: 'Замовлень',
      analyticsRevenue: 'Виручка',
      analyticsAvgCheck: 'Середній чек',
      analyticsNewCustomers: 'Нових клієнтів',
      analyticsReturningCustomers: 'Повторних клієнтів',
      analyticsRevenueTrend: 'Виручка за 30 днів',
      auctionsNav: 'Аукціони',
      auctionsTitle: 'Аукціони',
      auctionsText: 'Створення та керування аукціонами товарів.',
      auctionStatusActive: 'Активний',
      auctionStatusClosed: 'Завершено',
      auctionStatusCancelled: 'Скасовано',
      auctionCurrentPrice: 'Поточна ціна',
      auctionStartPrice: 'Стартова ціна',
      auctionEndsAt: 'Закінчується',
      auctionNoWinner: 'Ставок ще немає',
      cancelAuction: 'Скасувати аукціон',
      cancelAuctionConfirm: 'Скасувати цей аукціон?',
      auctionCancelled: 'Аукціон скасовано',
      noAuctions: 'Ще немає аукціонів.',
      createAuctionTitle: 'Новий аукціон',
      auctionProductId: 'ID товару',
      auctionStartPriceInput: 'Стартова ціна, USD',
      auctionMinStep: 'Мінімальний крок ставки, USD',
      auctionDurationHours: 'Тривалість, годин',
      auctionAutoExtend: 'Автопродовження, хвилин (0 = вимкнено)',
      createAuctionAction: 'Створити аукціон',
      auctionCreated: 'Аукціон створено',
      validationAuctionProductRequired: 'Вкажіть ID товару',
      validationAuctionPriceInvalid: 'Вкажіть коректну стартову ціну',
      deliveryNav: 'Доставка',
      deliveryTitle: 'Служби доставки',
      deliveryText: 'Керування службами доставки, доступними при оформленні замовлення.',
      deliveryStatusActive: 'Активна',
      deliveryStatusInactive: 'Вимкнена',
      toggleDeliveryProvider: 'Перемкнути',
      deleteDeliveryProvider: 'Видалити',
      deleteDeliveryProviderConfirm: 'Видалити цю службу доставки?',
      noDeliveryProviders: 'Ще немає служб доставки.',
      createDeliveryProviderTitle: 'Нова служба доставки',
      deliveryProviderNameUk: 'Назва українською',
      deliveryProviderNameEn: 'Назва англійською',
      deliveryProviderIcon: 'Іконка (емодзі)',
      createDeliveryProviderAction: 'Додати службу',
      deliveryProviderCreated: 'Службу доставки додано',
      validationDeliveryNameRequired: 'Вкажіть назву українською',
      deliveryAutomationTitle: 'Автоматизація доставки',
      deliveryAutomationText: 'Автоматичне оновлення статусів замовлень та сповіщення клієнтів (Нова Пошта / Укрпошта).',
      deliveryAutoDone: 'Авто-завершення замовлень',
      deliveryAutoDoneDesc: 'Автоматично переводити замовлення в статус "Виконано", коли посилку отримано клієнтом.',
      deliveryArrivedNotify: 'Сповіщення про прибуття',
      deliveryArrivedNotifyDesc: 'Надсилати клієнту сповіщення в Telegram, коли посилка прибуває у відділення або поштомат.',
      promoCodesNav: 'Промокоди',
      promoCodesTitle: 'Промокоди',
      promoCodesText: 'Створюйте та керуйте промокодами для знижок у чекауті.',
      noPromoCodes: 'Ще немає промокодів.',
      pausePromoCode: 'Призупинити',
      resumePromoCode: 'Відновити',
      deletePromoCode: 'Видалити',
      deletePromoCodeConfirm: 'Видалити цей промокод?',
      createPromoCodeTitle: 'Новий промокод',
      createPromoCodeHint: 'Вкажіть відсоткову АБО фіксовану знижку — якщо задані обидві, застосується відсоткова.',
      promoCode: 'Код',
      promoDiscountPercent: 'Знижка, %',
      promoDiscountFixed: 'Знижка, грн',
      promoMaxUses: 'Ліміт використань (0 = без ліміту)',
      createPromoCodeAction: 'Додати промокод',
      promoCodeCreated: 'Промокод додано',
      validationPromoCodeRequired: 'Вкажіть код промокоду',
      reviewsNav: 'Відгуки',
      reviewsTitle: 'Модерація відгуків',
      reviewsText: 'Відгук з’являється на сторінці товару лише після схвалення тут.',
      loadingReviews: 'Завантаження відгуків...',
      noPendingReviews: 'Немає відгуків на модерації.',
      approveReview: 'Схвалити',
      rejectReview: 'Відхилити',
      backupNav: 'Бекапи',
      backupTitle: 'Резервні копії',
      backupText: 'Підключення Google Drive, миттєвий бекап, завантаження та відновлення бази.',
      gdriveConnectionTitle: "Підключення Google Drive",
      gdriveConnectedAs: 'Підключено:',
      gdriveNotConnected: 'Google Drive не підключено.',
      gdriveNotConfigured: 'OAuth не налаштований на сервері (GOOGLE_OAUTH_CLIENT_ID/SECRET) і немає service-account credentials.',
      gdriveConnect: 'Підключити Google Drive',
      gdriveDisconnect: 'Відключити',
      gdriveDisconnected: 'Google Drive відключено',
      backupActionsTitle: 'Дії',
      backupNowAction: 'Бекап у Google Drive зараз',
      backupNowHint: 'Відновлення повністю замінює поточну базу даних — переконайтесь, що завантажуєте правильний файл.',
      backupNowSuccess: (n: number) => `Завантажено ${n} файл(ів) у Google Drive`,
      backupNowPartial: (n: number, failed: string) => `Завантажено ${n} файл(ів), але не вдалося: ${failed}`,
      backupNowFailed: 'Не вдалося завантажити бекап у Google Drive',
      backupEmailNowAction: 'Бекап на Email зараз',
      backupEmailSuccess: (to: string, kb: number) => `Бекап (${kb} KB) успішно надіслано на ${to}`,
      backupEmailFailed: 'Не вдалося надіслати бекап на Email',
      loadingAnalytics: 'Завантаження аналітики...',
      loadFailed: 'Не вдалося завантажити дані',
      downloadBackupAction: 'Завантажити бекап (.jsonl)',
      restoreAction: 'Відновити з файлу',
      restoreConfirm: 'Поточна база даних буде повністю замінена вмістом цього файлу. Продовжити?',
      restoreSuccess: (n: number) => `Відновлено ${n} рядків`,
      restoreFailed: 'Не вдалося відновити базу даних',
      logoFileId: 'Лого магазину: Telegram file_id',
      contactsUk: 'Контакти українською',
      contactsEn: 'Контакти англійською',
      storeSlug: 'Slug магазину',
      noStores: 'Поки що немає магазину',
      noStoresText: 'Створіть базову картку магазину, щоб одразу перейти до товарів і категорій.',
      categoryCreateTitle: 'Категорії магазину',
      categoryCreateText: 'Категорії створюються окремо і мають бути унікальними по назві.',
      categoryCreated: 'Категорію створено',
      categoryNameTaken: 'Категорія з такою назвою вже існує',
      createCategoryAction: 'Створити категорію',
      validationStoreLogoRequired: 'Додайте logo file_id магазину',
      validationStoreSlugRequired: 'Вкажіть slug магазину',
      validationStoreNameRequired: 'Вкажіть назву магазину українською',
      selectProduct: 'Оберіть товар',
      selectProductText: 'Праворуч відкриється безпечний редактор тільки для доступного вам товару.',
      createProduct: 'Новий товар',
      createProductText: 'Спочатку створюємо товар з мінімальним набором: назва та категорія. Усе інше редагується вже на сторінці товару.',
      createProductAction: 'Створити товар',
      saveChanges: 'Зберегти зміни',
      saving: 'Зберігаємо...',
      productCreated: 'Товар створено',
      productSaved: 'Зміни збережено',
      productDeleted: 'Товар видалено',
      saveFailed: 'Не вдалося зберегти зміни',
      deleteFailed: 'Не вдалося видалити',
      deleteProduct: 'Видалити товар',
      deleteProductConfirm: 'Видалити цей товар?',
      itemRemoved: 'Елемент видалено',
      productStore: 'Магазин товару',
      noStoreScope: 'Без окремого магазину',
      productCategory: 'Категорія',
      selectCategory: 'Оберіть категорію',
      nameSingle: 'Назва',
      nameUk: 'Назва українською',
      nameEn: 'Назва англійською',
      descriptionSingle: 'Опис',
      descriptionUk: 'Опис українською',
      descriptionEn: 'Опис англійською',
      descriptionTab: 'Опис',
      previousStep: 'Назад',
      nextStep: 'Далі',
      editSection: 'Редагувати',
      markdown: {
        source: 'Markdown',
        preview: 'Попередній перегляд',
        empty: 'Опис зʼявиться тут під час набору.',
        bold: 'Жирний текст',
        italic: 'Курсив',
        list: 'Список',
        link: 'Посилання',
      },
      priceUsd: 'Ціна в USD',
      productionDays: 'Днів на виготовлення',
      readyToShip: 'Готовий до відправки',
      basicInfoTitle: 'Базова інформація',
      basicInfoText: 'Назви, описи і категорія. Це головна картка товару для редагування контенту.',
      productSlug: 'URL Slug',
      productSlugHelp: 'Пряме посилання на товар: /product/slug або /app/catalog/slug',
      commerceTitle: 'Ціна та наявність',
      commerceText: 'Окремий блок для ціни, статусу наявності й виготовлення під замовлення.',
      mediaTitle: 'Фото та відео',
      mediaText: 'Основне фото, галерея і YouTube редагуються окремо, щоб мобільний екран не перевантажувався.',
      mediaSummaryNoVideo: 'Без YouTube',
      telegramUploadTitle: 'Швидке додавання фото через Telegram',
      telegramUploadText:
        'Якщо вам зручніше працювати через Telegram, відкрийте бота, додайте фото або посилання на зображення там, а потім поверніться сюди й оновіть картку товару.',
      openTelegramBot: 'Відкрити бота',
      refreshProductCard: 'Оновити картку',
      noPrimaryPhoto: 'Немає фото',
      youtubeLink: 'YouTube-посилання',
      primaryPhotoFileId: 'Основне фото: Telegram file_id',
      primaryPhotoSourceUrl: 'Основне фото: source URL',
      galleryTitle: 'Галерея',
      galleryText: 'Додавайте окремі gallery-фото через file_id. Основне фото редагується вище.',
      galleryPhotoFileId: 'Фото галереї: Telegram file_id',
      galleryPhotoSourceUrl: 'Фото галереї: source URL',
      addGalleryPhoto: 'Додати фото в галерею',
      photoAdded: 'Фото додано',
      photoReordered: 'Порядок фотографій оновлено',
      primaryPhotoLabel: 'Основне фото',
      galleryPhotoLabel: 'Фото галереї',
      makePrimaryPhoto: 'Зробити головним',
      movePhotoUp: 'Вгору',
      movePhotoDown: 'Вниз',
      deletePhotoConfirm: 'Видалити це фото?',
      optionsTitle: 'Опції та варіанти',
      optionsText: 'Групи опцій і варіанти додаються окремо, щоб не тримати на клієнті великий вкладений form state.',
      specsTitle: 'Характеристики',
      specsText: 'Ключові властивості товару для картки, фільтрів, квізу і порівняння.',
      specsSummary: 'редаговані характеристики',
      specNameSingle: 'Характеристика',
      specNameUk: 'Характеристика українською',
      specNameEn: 'Характеристика англійською',
      specValueSingle: 'Значення',
      specValueUk: 'Значення українською',
      specValueEn: 'Значення англійською',
      sortOrder: 'Порядок сортування',
      addSpec: 'Додати характеристику',
      saveSpec: 'Зберегти характеристику',
      specAdded: 'Характеристику додано',
      specSaved: 'Характеристику збережено',
      deleteSpecConfirm: 'Видалити цю характеристику?',
      kitTabTitle: 'Комплект',
      kitTabText: 'Зробіть цей товар набором з інших товарів (наприклад, аромобокс) — ціна лишається своя, склад впливає лише на списання залишків.',
      kitIsKitBadge: 'Це комплект',
      kitNoItems: 'До комплекту ще не додано товарів.',
      kitAddItemTitle: 'Додати товар до комплекту',
      kitSearchPlaceholder: 'Почніть вводити назву товару…',
      kitNoSearchResults: 'Нічого не знайдено.',
      kitAddAction: 'Додати',
      kitSearchScopeHint: 'Пошук серед перших 50 товарів цього магазину.',
      kitQuantity: 'Кількість',
      kitSaveAction: 'Зберегти склад комплекту',
      kitSaved: 'Склад комплекту збережено',
      addOption: 'Додати опцію',
      optionAdded: 'Опцію додано',
      optionNameSingle: 'Опція',
      optionNameUk: 'Опція українською',
      optionNameEn: 'Опція англійською',
      deleteOptionConfirm: 'Видалити цю опцію разом з її варіантами?',
      addVariant: 'Додати варіант',
      variantAdded: 'Варіант додано',
      variantNameSingle: 'Варіант',
      variantNameUk: 'Варіант українською',
      variantNameEn: 'Варіант англійською',
      variantPriceDiff: 'Надбавка в USD',
      variantPhotoFileId: 'Variant photo file_id',
      defaultVariant: 'Варіант за замовчуванням',
      deleteVariantConfirm: 'Видалити цей варіант?',
      remove: 'Видалити',
      variantStock: 'Залишок',
      variantStockUnlimited: 'Без обліку',
      saveStock: 'Зберегти',
      stockSaved: 'Залишок оновлено',
      validationCategoryRequired: 'Оберіть категорію',
      validationNameRequired: 'Вкажіть назву українською',
      validationPriceInvalid: 'Вкажіть коректну ціну в USD',
      validationYoutubeInvalid: 'Вкажіть коректне YouTube-посилання',
      validationDaysInvalid: 'Дні виготовлення мають бути цілим числом від 0 до 365',
      validationPhotoRequired: 'Вкажіть Telegram file_id для фото',
      validationOptionRequired: 'Вкажіть назву опції українською',
      validationVariantRequired: 'Вкажіть назву варіанту українською',
      validationVariantPriceInvalid: 'Вкажіть коректну надбавку для варіанту',
      validationVariantStockInvalid: 'Залишок має бути цілим невід’ємним числом',
      validationSpecNameRequired: 'Вкажіть назву характеристики українською',
      validationSpecValueRequired: 'Вкажіть значення характеристики українською',
      validationSpecSortInvalid: 'Порядок сортування має бути числом від 0 до 365',
      noAccessTitle: 'Немає доступу до адмінки',
      noAccessText: 'Цей окремий застосунок показуємо тільки продавцям, менеджерам і супер адмінам.',
      loginRequiredTitle: 'Потрібен вхід',
      loginRequiredText: 'Спочатку увійдіть у магазин, а потім відкрийте адмінку ще раз.',
      openLogin: 'Відкрити логін',
      serverErrorTitle: 'Помилка сервера',
      serverErrorText: 'Не вдалося зв’язатися із сервером або сталася помилка. Спробуйте оновити сторінку.',
      retry: 'Спробувати знову',
      fillWithAi: '✨ Заповнити з ШІ',
      aiModalTitle: 'Вставте опис або сирий текст товару для розпізнавання ШІ',
      aiModalPlaceholder: 'Скопіюйте сюди текст з сайту постачальника, ноти аромату, назву або ціну...',
      aiParseAction: '🪄 Розпарсити та заповнити',
      aiParsing: 'Розпізнавання...',
      aiParseError: 'Не вдалося розпізнати текст через ШІ',
      closeAction: 'Закрити',
      specsTab: 'Характеристики',
      specsSubtitle: 'Задайте ноти, концентрацію, сімейство ароматів та інші атрибути',
      specsEmpty: 'У цього товару ще немає характеристик.',
      specCode: 'Код характеристики',
      specCodeSlug: 'Код характеристики (slug)',
      addSpecTitle: 'Додати нову характеристику',
      addSpecSubtitle: 'Виберіть відомий шаблон або створіть власний атрибут',
      specPresetsLabel: 'Швидкі пресети з каталогу:',
      specCachedValuesLabel: 'Існуючі значення в кеші:',
      addVariantGroupTitle: "Створити нову групу опцій (наприклад: Об'єм)",
      addVariantToOptionTitle: 'Додати варіант опції',
      addGalleryPhotoTitle: 'Додати фото в галерею',
      seoTab: 'SEO / Google Оптимізація',
      seoTagsTitle: 'Налаштування SEO тегів',
      seoTagsSubtitle: 'Задайте унікальні заголовки та описи для пошукових систем Google',
      metaTitleUk: 'Meta Title (UK) — Заголовок у Google',
      metaTitleEn: 'Meta Title (EN)',
      metaDescriptionUk: 'Meta Description (UK) — Опис у результатах пошуку',
      metaDescriptionEn: 'Meta Description (EN)',
      seoAuditTitle: 'SEO / Google Аудит',
      seoAuditSubtitle: 'Попередній перегляд у Google та аудит оптимізації товару',
    },
  },
  en: {
    common: {
      actionFailed: 'Could not save changes. Please try again.',
      loading: 'Loading...',
      error: 'Failed to load',
      total: 'Total',
      paid: 'Paid',
      unpaid: 'Awaiting payment',
      consentText: 'We use analytics to improve the site. By continuing, you agree.',
      consentAccept: 'Accept',
      consentDecline: 'Decline',
      watchOnYoutube: 'Watch on YouTube',
      close: 'Close',
    },
    fopModal: {
      title: 'Bank Requisites (FOP / IBAN)',
      subtitle: 'Fast & secure payment via banking apps',
      loading: 'Loading requisites...',
      notConfigured: 'Bank requisites are temporarily not configured.',
      recipient: 'Recipient (FOP)',
      amount: 'Exact Amount',
      purpose: 'Payment Purpose',
      bankCard: 'Bank Card',
      extraInfo: 'Additional Info / Bank',
      scanQrHint: 'Scan QR code in your banking app for instant payment',
      copyIban: 'Copy IBAN',
      copied: 'Copied!',
    },
    nav: {
      home: 'Home',
      catalog: 'Catalog',
      quiz: 'Quiz',
      services: 'Services',
      auctions: 'Auctions',
      cart: 'Cart',
      profile: 'Profile',
      stories: 'Articles',
      wishlist: 'Wishlist',
      brands: 'Brands',
    },
    brands: {
      officialBrand: 'Official Brand',
      outOfStock: 'Out of stock',
      title: 'Brands',
      allBrands: 'All Brands',
      subtitle: 'Original niche and selective perfumery from premier world houses',
      searchPlaceholder: 'Search brand...',
      allLetters: 'All',
      productCount: (count: number) => `${count} product${count === 1 ? '' : 's'}`,
      noBrandsFound: 'No brands found for your query',
      noProductsFound: 'No in-stock products available for this brand at the moment',
      backToBrands: 'All brands',
      allCategories: 'All categories',
      allGenders: 'All genders',
      viewProducts: 'View products',
      filterCategory: 'Category',
      filterGender: 'Gender',
      sortBy: 'Sort by',
      sortPopular: 'Most popular',
      sortPriceAsc: 'Price: Low to High',
      sortPriceDesc: 'Price: High to Low',
      sortNewest: 'New arrivals',
      priceFrom: 'from',
      aboutBrand: 'About the Brand',
      readMore: 'Read more',
      showLess: 'Show less',
      viewAllInCatalog: (count: number) => `View all products in catalog (${count})`,
    },
    specs: {
      title: 'Specification',
      allSpecs: 'All specifications',
      backToCatalog: 'Back to catalog',
      productsWithSpec: (name: string) => `Products with "${name}"`,
      productCount: (count: number) => `${count} product${count === 1 ? '' : 's'}`,
      viewAllInCatalog: (count?: number) => count && count > 0 ? `View all products in catalog (${count})` : 'View all products in catalog',
      readMore: 'Read more',
      showLess: 'Show less',
      noProducts: 'No products with this specification found',
      aboutAttribute: 'About this attribute',
      priceFrom: 'from',
      sortBy: 'Sort by',
      sortPriceAsc: 'Price: Low to High',
      sortPriceDesc: 'Price: High to Low',
      sortNewest: 'New arrivals',
    },
    home: {

      shopNow: 'Shop now',
      categoriesTitle: 'Categories',
      newProductsTitle: 'New arrivals',
      quizBannerTitle: 'Find your scent',
      quizBannerCta: 'Take the quiz',
      mayparfumEyebrow: 'Niche perfume and decants',
      mayparfumTitle: 'MAY PARFUM',
      mayparfumSubtitle:
        'Original scents, decants, and rare bottles for people who want to feel the story on skin first.',
      mayparfumPrimary: 'Choose a scent',
      mayparfumSecondary: 'Perfume culture',
      mayparfumTrust: ['Originality', 'Decants', 'Fast dispatch'] as string[],
      mayparfumWelcomeEyebrow: 'Welcome to the world of scent',
      mayparfumWelcomeTitle: 'Discover new horizons of perfumery',
      mayparfumWelcomeBody:
        'MAY PARFUM is a space for niche, selective, authorial, and artisanal perfume. Find a scent for a mood, season, or meaningful moment, then get to know it in a comfortable format.',
      mayparfumBrandsTitle: 'Brands in curation',
      mayparfumChannelTitle: 'Current scents from the @mayparfum_nspl Telegram channel',
      mayparfumStoriesTitle: 'Perfume culture',
      mayparfumStoriesSubtitle: 'Short guides to help you choose perfume with more attention.',
      mayparfumCatalogHint: 'Browse arrivals, curated picks, and scents for the moment.',
      mayparfumHighlights: [
        {
          title: 'Personal selection',
          body: 'Curated choices by character, season, occasion, and favorite notes.',
        },
        {
          title: 'Aroma boxes',
          body: 'A convenient way to meet several scents before choosing a bottle.',
        },
        {
          title: 'Perfume culture',
          body: 'Articles and reviews that make compositions easier to understand.',
        },
      ] as { title: string; body: string }[],
    },
    stories: {
      fragranceQuiz: 'Fragrance Quiz',
      storiesCultureTitle: 'PERFUME CULTURE',
      storiesCultureSubtitle: 'Guides & Knowledge Base',
      storiesCultureDescription: 'Everything you need to know about niche fragrances, decants, longevity and application.',
      searchPlaceholder: 'Search articles...',
      noArticlesFound: 'No articles found matching query.',
      readGuide: 'Read guide',
    },
    quizNav: {
      title: 'Product finder',
      step: 'Question {current} of {total}',
      next: 'Next',
      back: 'Back',
      viewResults: 'View matches',
      startOver: 'Start over',
      foundCount: 'Found: {count}',
      noMatches: 'No matches — try removing an answer or two',
      results: 'Results',
      profileTitle: 'Your Olfactory Profile',
      profileSub: 'Crafted from your preferences and chosen accords',
      copyProfile: 'Copy profile',
      copied: 'Copied!',
      shareProfile: 'Share',
      tweakAnswers: 'Tweak answers',
      retakeQuiz: 'Retake quiz',
      matchReason: 'Matches your profile',
      whyMatch: 'Recommended perfumes matching your profile',
      matchedAccords: 'Matches',
    },
    page: {
      notFound: 'Page not found',
    },
    catalog: {
      fragranceCatalog: 'Fragrance Catalog',
      fragranceCatalogShop: (shop: string) => `Fragrance Catalog — ${shop}`,
      fromPrice: 'from',
      perNight: '/ night',
      book: 'Book',
      details: 'Details',
      title: 'Catalog',
      loading: 'Loading...',
      search: 'Search products...',
      all: 'All',
      allStores: 'All stores',
      empty: 'No products found',
      categoriesTitle: 'Categories',
      wishlist: 'Wishlist',
      mto: 'Made to order',
      addToCart: 'Add',
      adding: '...',
      outOfStock: 'Out of stock',
      addFail: 'Failed to add to cart. Please try again.',
      filterBtn: 'Filter',
      resultCount: (count: number) => `${count} ${count === 1 ? 'product' : 'products'}`,
      filters: {
        title: 'Filters',
        legend: 'Tap: include → exclude → reset',
        selected: 'Selected',
        searchPlaceholder: 'Search...',
        noMatches: 'No matches',
        showMore: 'Show more',
        showLess: 'Show less',
        priceRange: 'Price, UAH',
        priceRangeWithCurrency: (currency: string) => `Price, ${currency}`,
        priceMin: 'Min',
        priceMax: 'Max',
        variant: 'Variant',
        variantAny: "Doesn't matter",
        clear: 'Clear filters',
        apply: 'Show results',
      },
    },
    cart: {
      title: 'Cart',
      decrease: 'Decrease quantity',
      increase: 'Increase quantity',
      remove: 'Remove',
      loading: 'Loading...',
      empty: 'Cart is empty',
      checkout: (uah: number) => `Checkout — ${uah} UAH`,
      clear: 'Clear cart',
      total: 'Total',
      mtoSingle: 'Made to order',
      mtoEta: (d: number) => `🕒 Expected production time: ~${d} days`,
      mtoGeneric: '🕒 Some items are made to order',
    },
    checkout: {
      goToCatalog: 'Go to catalog',
      backToCart: 'Back to cart',
      addItems: '+ Add items',
      fopIbanTitle: 'Official FOP Account (IBAN)',
      viewFopRequisites: 'View requisites',
      fopPaymentInfo: 'After placing the order, you will receive full bank requisites and QR code to pay via any Ukrainian banking app.',
      manualPaymentInfo: 'Payment details will be coordinated by the manager upon order confirmation.',
      title: 'Checkout',
      loading: 'Loading...',
      name: 'Name',
      contact: 'Phone number',
      deliveryType: 'Delivery type',
      city: 'City',
      delivery: 'Delivery / branch',
      comment: 'Comment',
      promo: 'Promo code',
      payment: 'Payment method',
      securePayment: 'Secure payment',
      submit: (uah: number) => `Order — ${uah} UAH`,
      submitting: 'Placing order...',
      emptyCart: 'Cart is empty',
      deliveryTypes: [
        { value: '', label: 'Not selected' },
        { value: 'nova_poshta', label: 'Nova Poshta' },
        { value: 'ukrposhta', label: 'Ukrposhta' },
      ] as { value: string; label: string }[],
      errors: {
        name_required: 'Enter your name',
        contact_required: 'Enter phone number',
        city_required: 'Enter city',
        delivery_required: 'Enter branch or address',
        contact_invalid: 'Enter a valid phone number (e.g. +380501234567)',
        promo_invalid: 'Promo code is invalid or expired',
      },
      applyPromo: 'Apply',
      promoApplied: 'Promo code applied',
      discount: 'Discount',
    },
    orders: {
      title: 'My orders',
      loading: 'Loading...',
      empty: 'No orders yet',
      paid: 'Paid',
      unpaid: 'Awaiting payment',
      payOnline: 'Pay online',
      payOnlineAmount: (amount: number) => `💳 Pay online (${amount} UAH)`,
      paying: 'Redirecting to payment...',
      payFailed: 'Failed to create payment. Please try again later.',
      codNote: '📦 Cash on delivery (pay upon receipt)',
      total: 'Total',
      reorder: '🔄 Reorder',
      reordering: '...',
      reorderFail: '❌ Unavailable',
      delete: 'Delete',
      tracking: 'Tracking',
      deliveryStatus: 'Delivery status',
      deliveryEstimated: 'Estimated delivery',
      deliveryInTransit: 'In transit',
      deliveryArrived: 'Arrived at branch',
      deliveryReceived: 'Delivered',
      trackNovaPoshta: 'Track on Nova Poshta',
      trackUkrposhta: 'Track on Ukrposhta',
      copy: 'Copy',
      copied: 'Copied',
      deleteConfirm: (id: number) =>
        `Delete order #${id}? Only possible while the shop hasn't started processing it.`,
      deleteSeenError:
        "The shop has already started processing this order — contact us to cancel.",
      status: {
        new: 'New',
        seen: 'Processing',
        shipped: 'Shipped',
        done: 'Done',
        cancelled: 'Cancelled',
        refunded: 'Refunded',
      },
      changePayment: 'Change payment method',
      paymentMethod: 'Payment method',
      paymentMethodUpdated: 'Payment method updated',
      buyAgain: 'Buy again',
      addMore: 'Add to cart',
      itemAddedToCart: 'Item added to cart',
      orderSupport: 'Order support',
      copyOrderDetails: 'Copy details',
      orderDetailsCopied: 'Order details copied',
      timeline: {
        new: 'Placed',
        seen: 'Processing',
        shipped: 'Shipped',
        done: 'Delivered',
      },
      paymentMethods: {
        liqpay: 'LiqPay (Card / Apple Pay / Google Pay)',
        monopay: 'Monobank (MonoPay / Card)',
        stripe: 'Stripe (Apple Pay / Card / BLIK)',
        sandbox: 'Test Payment (Sandbox)',
        manual: 'Bank transfer (IBAN)',
        cod: 'Cash on delivery (COD)',
        telegram: 'Telegram Stars',
        pay_on_site: 'Pay on site',
      },
      sandboxPayment: {
        title: 'Test Payment (Sandbox)',
        subtitle: 'Payment gateway simulator for testing',
        orderNumber: 'Order #',
        amount: 'Amount due',
        selectMethod: 'Select test payment method',
        card: 'Test Card (Visa / Mastercard)',
        applePay: 'Apple Pay (Simulated)',
        blik: 'BLIK (Test code: 123456 / 777123)',
        cardHint: 'Uses virtual test card 4242 4242 4242 4242',
        blikHint: 'For BLIK testing, any 6-digit code works (e.g. 123456 or 777123)',
        simulateSuccess: '✅ Simulate Success Payment',
        simulateFail: '❌ Simulate Payment Decline',
        processing: 'Processing simulated payment...',
        successTitle: 'Payment completed successfully!',
        successText: 'Order marked as paid, fiscalization and notifications dispatched.',
        failedTitle: 'Payment declined',
        failedText: 'The simulator declined the test transaction. You can try again.',
        backToOrders: 'Back to my orders',
        tryAgain: 'Try again',
      },
    },
    product: {
      fastDeliveryTitle: 'Fast Delivery across Ukraine',
      fastDeliveryText: 'Nova Poshta (branches, parcel lockers, courier) & Ukrposhta. Dispatch within 1-2 days.',
      officialFopTitle: 'Official FOP Payment / IBAN',
      officialFopText: 'Online card payment, official IBAN account (Monobank, Privat24) or cash on delivery.',
      kitContents: 'Kit Contents:',
      spraysEstimate: (sprays: number) => `≈ ${sprays} sprays`,
      free: 'Free',
      back: 'Back to catalog',
      notFound: 'Product not found',
      addToCart: 'Add to cart',
      adding: 'Adding...',
      added: 'In cart',
      madeToOrder: 'Made to order',
      watchVideo: 'Watch video',
      share: 'Share',
      addToWishlist: 'Add to wishlist',
      inWishlist: 'In wishlist',
      description: 'Description',
      attributes: 'Attributes',
      filterByAttribute: 'Show similar',
      outOfStock: 'Out of stock',
      shareSuccess: 'Link copied',
      shareError: 'Unable to share',
      addFail: 'Failed to add to cart. Please try again.',
      relatedTitle: 'You may also like',
      noReviewsYet: 'no reviews yet',
      reviewsCount: (n: number) => `${n} review${n === 1 ? '' : 's'}`,
      writeReview: 'Write a review',
      reviewCommentPlaceholder: 'Your review (optional)',
      reviewSubmit: 'Submit',
      reviewSubmitting: 'Submitting...',
      reviewCancel: 'Cancel',
      reviewSubmitted: 'Thanks! Your review will appear once a moderator approves it.',
      reviewSubmitFailed: 'Failed to submit the review. Please try again.',
    },
    wishlist: {
      title: 'Wishlist',
      loading: 'Loading...',
      empty: 'No saved products yet',
      clear: 'Clear',
      addToCart: 'Add to cart',
      adding: '...',
      outOfStock: 'Out of stock',
      openCatalog: 'Open catalog',
      addFail: 'Failed to add to cart. Please try again.',
    },
    auctions: {
      title: 'Auctions',
      loading: 'Loading...',
      empty: 'No active auctions',
      disabled: 'Auctions are currently disabled',
      bids: 'bids',
      ended: 'Ended',
    },
    auction: {
      back: 'Back to auctions',
      notFound: 'Not found',
      disabled: 'Auctions are currently disabled',
      bids: 'bids',
      ended: 'Ended',
      winning: "You're winning!",
      recentBids: 'Recent bids',
      bidder: 'Bidder',
      you: 'You',
    },
    services: {
      title: 'Services',
      empty: 'No services yet',
      provider: 'Specialist',
      date: 'Day',
      time: 'Time',
      noSlots: 'No free slots on this day',
      notes: 'Booking note',
      add: 'Add to cart',
      adding: 'Adding...',
      slotTaken: 'This time is already booked. Pick another slot.',
      calendarConflict:
        '⏳ Added to cart. This booking needs approval — the specialist has another event at this time.',
      min: 'min',
      back: '← Back',
    },
    bookings: {
      title: 'My bookings',
      empty: 'No bookings yet',
      paid: 'Paid',
      unpaid: 'Awaiting payment',
      filters: {
        all: 'All',
        active: 'Active',
        past: 'Past',
        cancelled: 'Cancelled',
      },
      anyDay: 'Any day',
      service: 'Service',
      provider: 'Specialist',
      contact: 'Contact',
      created: 'Created',
      notes: 'Note',
      addToCalendar: 'Add to calendar',
      cancel: 'Cancel',
      cancelling: '...',
      confirmCancel: (id: number) => `Cancel booking #${id}?`,
      calendarPending: '⚡ Pending approval due to calendar conflict',
      cancellationReason: 'Cancellation reason',
      status: {
        pending: 'Pending',
        confirmed: 'Confirmed',
        cancelled: 'Cancelled',
        done: 'Done',
        no_show: 'No-show',
      },
    },
    profile: {
      title: 'Profile',
      subtitle: 'Manage your details and keep only the sections you actually use',
      error: 'Failed to load',
      editProfile: 'Edit profile',
      editProfileHint: 'Name, contact details, language, and saved delivery',
      myOrders: 'My orders',
      myOrdersHint: 'History, reorder, and delete',
      myBookings: 'My bookings',
      myBookingsHint: 'Upcoming bookings and cancellation',
      createStore: 'Become a seller',
      createStoreHint: 'Create your own shop and manage products separately',
      becomingSeller: 'Opening seller access...',
      openAdmin: 'Open admin',
      openAdminHint: 'Separate app for seller or manager work',
      login: 'Sign in',
      loginHint: 'Sign in to see orders, bookings, and saved details',
      logout: 'Sign out',
      logoutHint: 'End the current session',
      loggingOut: 'Signing out...',
      guestName: 'Guest',
      guestContact: 'Sign in to manage your profile',
      nameFallback: 'No name yet',
      noContact: 'Add a phone or email',
      noDelivery: 'Delivery is not set yet',
      interfaceLanguage: 'Interface language',
      languageLabels: { uk: 'Ukrainian', en: 'English', ru: 'Russian' } as Record<string, string>,
      deliveryLabels: { nova_poshta: 'Nova Poshta', ukrposhta: 'Ukrposhta' } as Record<
        string,
        string
      >,
      infoTitle: 'Information',
      myActivity: 'My Activity',
      myWishlist: 'Wishlist',
      myWishlistHint: 'Saved items and quick access',
      perfumeProfile: 'Olfactory Profile',
      perfumeProfileHint: 'Your personalized fragrance archetype',
      perfumeQuizCta: 'Find your fragrance',
      perfumeQuizCtaHint: 'Take the quiz to discover your perfume archetype',
      guidesTitle: 'Guides & Articles',
      perfumeGuides: 'Perfume Guides & Articles',
      perfumeGuidesHint: '7 guides on niche perfumes, decants, and longevity',
      articlesAndGuides: 'Articles & Guides',
      articlesAndGuidesHint: (count: number) =>
        count > 0 ? `${count} useful guides and articles` : 'Useful guides and articles',
      helpAndRules: 'Service & Policies',
      supportTelegram: 'Support on Telegram',
      supportTelegramHint: 'Chat directly with our manager',
      storeInfoAndRules: 'About store & Policies',
      storeInfoAndRulesHint: 'Delivery, payment, privacy and terms',
      accountSettings: 'Settings',
      referralTitle: 'Refer a friend',
      referralHint: (percent: number) =>
        `Share your code — a new customer gets ${percent}% off, and you get a bonus toward your next order.`,
      referralCopy: 'Copy code',
      referralShare: 'Share',
      referralCopied: 'Code copied',
      referralShareText: (code: string, percent: number, shopName: string) =>
        `${percent}% off at ${shopName || 'our shop'} with code ${code}!`,
    },
    profileEdit: {
      title: 'Edit profile',
      back: 'Back to profile',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      delivery: 'Saved delivery',
      deliveryType: 'Delivery type',
      city: 'City',
      warehouse: 'Branch / Post office',
      save: 'Save',
      saving: 'Saving...',
      saved: '✅ Saved',
      logout: 'Sign out',
      language: 'Interface language',
      languageUk: '🇺🇦 Ukrainian',
      languageEn: '🇬🇧 English',
      error: 'Failed to load',
      emailHint: 'Used for email login and order receipts',
      phoneHint: 'Used to contact you about orders and delivery',
      deliveryHint: 'Pre-fills checkout automatically',
      phonePlaceholder: '+380...',
      cityPlaceholder: 'e.g. Kyiv',
      warehousePlaceholder: 'e.g. Branch #5',
      deliveryTypes: [
        { value: '', label: 'Not selected' },
        { value: 'nova_poshta', label: 'Nova Poshta' },
        { value: 'ukrposhta', label: 'Ukrposhta' },
      ] as { value: string; label: string }[],
    },
    login: {
      title: 'Sign in',
      loading: 'Loading...',
      subtitle: 'Choose the sign-in method that feels best. Each option leads to the same account.',
      telegramTitle: 'Telegram',
      telegramWidget: 'Sign in with Telegram',
      telegramHint: 'Fast browser sign-in using your Telegram account',
      googleTitle: 'Google',
      google: 'Sign in with Google',
      googleHint: 'Quick access with your Google account',
      emailTitle: 'Email',
      emailHint: 'We will send you a passwordless magic link',
      emailPlaceholder: 'your@email.com',
      emailBtn: 'Send magic link',
      emailSending: 'Sending...',
      emailSent: 'Link sent — check your inbox.',
      emailResend: 'Resend',
      emailError: 'Something went wrong. Try again.',
      openTelegram: 'Open shop in Telegram',
      openTelegramHint: 'Separate shortcut to Telegram, not part of browser sign-in',
      noProviders: 'Sign-in is temporarily unavailable.',
      guest: 'Continue as guest',
      guestHint: 'Browse without a profile now and sign in to an account later.',
      guestError: 'Could not start guest access.',
    },
    novaPoshta: {
      cityPlaceholder: 'Start typing a city',
      cityHint: 'Pick a city from the list to load branches',
      warehousePlaceholder: 'Start typing branch number or address',
      warehouseHint: 'Search branches by number or address text',
      loading: 'Loading...',
      notConfigured: 'Nova Poshta lookup is unavailable — manual entry still works.',
      noCities: 'No cities found',
      noWarehouses: 'No branches found',
      selectedCity: 'Selected city',
      selectedWarehouse: 'Selected branch',
      changeCity: 'Change city',
      changeWarehouse: 'Change branch',
    },
    ukrposhta: {
      byIndexTab: 'By postal index',
      byCityTab: 'By city',
      indexPlaceholder: '5-digit index (e.g. 01001)',
      indexHint: 'Enter 5-digit postal index',
      cityPlaceholder: 'Start typing a city',
      cityHint: 'Pick a city from the list',
      officePlaceholder: 'Select post office',
      officeHint: 'Search by index or address',
      loading: 'Loading...',
      notConfigured: 'Ukrposhta lookup is unavailable — manual entry still works.',
      noOffices: 'No post offices found',
      noCities: 'No cities found',
      selectedCity: 'Selected city',
      selectedOffice: 'Selected post office',
      changeCity: 'Change city',
      changeOffice: 'Change post office',
    },
    admin: {

      ordersCount: (count: number) => `Orders (${count})`,
      noOrdersFiltered: 'No orders match selected filters.',
      orderCardTitle: (id: number, date: string) => `Order #${id} · ${date}`,
      client: 'Client',
      contact: 'Contact',
      city: 'City',
      delivery: 'Delivery',
      items: 'Items',
      comment: 'Comment',
      changeStatus: 'Change status',
      markUnpaid: 'Mark as unpaid',
      archiveOrder: 'Archive',
      unarchiveOrder: 'Unarchive',
      statusUpdated: 'Status updated',
      paymentUpdated: 'Payment updated',
      archiveUpdated: 'Order updated',
      trackingNumber: 'Tracking / TTN',
      setTracking: 'Save tracking',
      fiscalizeAction: 'Fiscalize (Checkbox)',
      fiscalizeSuccess: 'Receipt successfully fiscalized!',
      fiscalizeError: 'Receipt fiscalization error',
      fiscalReceipt: 'Fiscal receipt',
      questionsNav: 'Questions',
      questionsTitle: 'Customer Questions',
      questionsPending: 'Pending',
      questionsAnswered: 'Answered',
      noQuestionsFiltered: 'No questions match selected filters.',
      questionFrom: (name: string, date: string) => `From: ${name} · ${date}`,
      questionProduct: 'Product:',
      answerPlaceholder: 'Enter response to customer...',
      answerSent: 'Response sent to customer via Telegram!',
      noReviews: 'No reviews to moderate.',
      reviewApproved: 'Review approved and published on site!',
      reviewRejected: 'Review rejected',
      reviewDeleteConfirm: 'Delete this review?',
      reviewDeleted: 'Review deleted',
      rating: 'Rating',
      reviewAuthor: 'Author',
      reviewComment: 'Review text',
      reviewDate: 'Date',
      importExportNav: 'Import / Export',
      importExportTitle: 'Data Import & Export',
      importExportText: 'Bulk export and import of catalog products via CSV/JSON.',
      exportProductsCsv: 'Export products to CSV',
      importProductsCsv: 'Import products from CSV',
      importProductsHint: 'Upload CSV file with schema: name_uk, price, category, ...',
      chooseCsvFile: 'Choose CSV file',
      startImport: 'Start import',
      importing: 'Importing products...',
      importSuccess: (count: number) => `Successfully imported ${count} products!`,
      importError: 'Error importing file',
      ordersStatusFilter: 'Status filter',
      ordersDateRange: 'Date range',
      customerProfile: 'Customer Profile',
      orderTimeline: 'Order timeline',
      paymentMethod: 'Payment method',
      deliveryAddress: 'Delivery address',
      fiscalCheckUrl: 'Fiscal receipt link',
      sendTelegramNotification: 'Send Telegram notification',
      notificationSent: 'Notification sent to customer',
      notificationFailed: 'Could not send notification',

      badge: 'Admin',
      title: 'Store control',
      backToShop: 'Back to shop',
      dashboard: 'Overview',
      storesNav: 'Stores',
      lodgingNav: 'Rooms',
      products: 'Products',
      bannersNav: 'Banners',
      bannersTitle: 'Home page banners',
      bannersSubtitle: 'Manage the banner slider on the shop home page.',
      addBannerAction: 'Add banner',
      closeForm: 'Close form',
      createBannerTitle: '➕ Create new banner',
      editBannerTitle: (id: number) => `Edit banner #${id}`,
      bannerImageUrl: 'Image URL',
      bannerImageUrlPlaceholder: '/shared-assets/banners/banner-name.png or https://...',
      readyPresets: 'Presets:',
      bannerAltText: 'Alt text / Title',
      bannerAltPlaceholder: 'E.g.: PANA DORA — Spring collection',
      bannerHref: 'Link (href)',
      bannerHrefPlaceholder: '/catalog or /catalog?category=perfume',
      bannerPreview: 'Preview:',
      bannerActiveLabel: 'Show in carousel (Active)',
      bannerActiveStatus: 'Active',
      bannerInactiveStatus: 'Inactive',
      createBannerSubmit: 'Create banner',
      saveBannerChanges: 'Save changes',
      bannersListTitle: (count: number) => `Banners list (${count})`,
      loading: 'Loading...',
      loadingBanners: 'Loading...',
      noBanners: 'No banners yet. Click "Add banner" above.',
      bannerAdded: 'Banner added successfully!',
      bannerSaved: 'Banner updated successfully!',
      bannerDeleted: 'Banner deleted!',
      deleteBannerConfirm: 'Delete this banner?',
      validationBannerUrlRequired: 'Banner image URL is required',
      moveUp: 'Move up',
      moveDown: 'Move down',
      enableBanner: 'Enable',
      disableBanner: 'Disable',
      noBannerTitle: 'Untitled',
      delete: 'Delete',
      orders: 'Orders',
      questions: 'Questions',
      services: 'Services',
      aiGuideNav: 'AI Guide',
      staffNav: 'Staff',
      navGroupOverview: 'Overview',
      navGroupCatalog: 'Catalog',
      navGroupSales: 'Sales',
      navGroupAdmin: 'Administration',
      scopeTitle: 'Access scope',
      scopeHint: 'Phase 1 stays intentionally simple: a separate app for daily seller or manager work.',
      welcome: 'React admin for daily operations',
      dashboardTitle: 'Store operations panel',
      dashboardText: 'Manage stores, products, and orders from one web screen. Access and data are already scoped by role and assigned stores.',
      role: 'Role',
      stores: 'Stores',
      phase: 'Stage',
      phaseValue: 'Backoffice rollout',
      scopedStores: 'Available stores',
      newOrders: 'New orders',
      pendingQuestions: 'Questions',
      recentOrders: 'Recent orders',
      recentOrdersText: 'The newest orders in your access scope.',
      openOrders: 'Open orders',
      openQuestions: 'Open questions',
      stockSnapshot: 'Stock snapshot',
      attention: 'Needs attention',
      attentionText: (unpaid: number, questions: number) =>
        `${unpaid} unpaid orders · ${questions} unanswered questions`,
      allStores: 'All available stores',
      productsText: 'Products are already filtered by role and allowed stores.',
      productsCrudText:
        'Create, update, and delete products here, then manage options, gallery photos, and the YouTube link without a heavy global admin state.',
      storeFilter: 'Store',
      prevPage: 'Previous',
      nextPage: 'Next',
      pageRange: (from: number, to: number, total: number) => `${from}-${to} of ${total}`,
      backToProducts: 'Back to products',
      currentScope: 'Current scope',
      currentCategory: 'Current category',
      loadingProducts: 'Loading products...',
      loadingProductEditor: 'Loading product editor...',
      loadingServices: 'Loading services...',
      loadingOrders: 'Loading orders...',
      madeToOrder: 'Made to order',
      stockItem: 'Stock item',
      inStock: 'In stock',
      outOfStock: 'Out of stock',
      activeService: 'Active',
      inactiveService: 'Hidden',
      minutes: 'min',
      daysShort: 'days',
      pcsShort: 'pcs',
      editLater: 'Editing lands in the next phase',
      noProducts: 'No accessible products yet',
      noProductsText: 'If you expected products here, we should verify the seller or manager store assignment.',
      searchProductPlaceholder: 'Search by name or ID...',
      filterAll: 'All',
      categoryFilter: 'Category',
      allCategories: 'All categories',
      errorLoadingProducts: 'Failed to load products.',
      noServices: 'No accessible services yet',
      noServicesText: 'Services from available stores will appear here once we continue the admin CRUD rollout.',
      errorLoadingServices: 'Failed to load services.',
      servicesText: 'Review services in accessible stores. Full service CRUD lands in the next phase.',
      servicesDisabledText: 'Service bookings are disabled in global settings.',
      ordersText: 'Process new orders, payment, delivery, fiscalization, and archive without jumping back into Telegram menus.',
      searchOrdersPlaceholder: 'Search (order #, client, phone, tracking)...',
      exportCsv: 'Export CSV',
      exportingCsv: 'Exporting...',
      copied: 'Copied!',
      copyPhone: 'Copy phone',
      copyAddress: 'Copy address',
      orderStatus: 'Status',
      allStatuses: 'All statuses',
      payment: 'Payment',
      allPayments: 'All payments',
      paid: 'Paid',
      unpaid: 'Awaiting payment',
      showArchive: 'Archive',
      noOrders: 'No orders found',
      noOrdersText: 'Change filters or verify store access.',
      orderTotal: 'Total',
      orderUpdated: 'Order updated',
      orderUpdateFailed: 'Failed to update order',
      trackingSaved: 'Tracking saved',
      orderPaidMarked: 'Payment marked',
      orderArchived: 'Order moved to archive',
      orderRestored: 'Order restored from archive',
      orderDeletedForever: 'Order deleted forever',
      refiscalizeQueued: 'Refiscalization queued',
      npCreateWaybill: 'Create NP waybill',
      npCityPlaceholder: 'Recipient city...',
      npWarehousePlaceholder: 'Branch...',
      npChangeCity: 'Change city',
      npChangeWarehouse: 'Change branch',
      npRecipientName: 'Recipient name',
      npRecipientPhone: 'Recipient phone',
      npWeightKg: 'Weight, kg',
      npSubmit: 'Create',
      npCancel: 'Cancel',
      npCreateFailed: 'Failed to create waybill',
      npWaybillCreated: 'Waybill created',
      tracking: 'Tracking',
      saveTracking: 'Save tracking',
      markPaid: 'Mark paid',
      refiscalize: 'Fiscalize',
      archive: 'Archive',
      restore: 'Restore',
      deleteForever: 'Delete forever',
      hardDeleteConfirm: (id: number) => `Delete order #${id} forever?`,
      receipt: 'Receipt',
      noReceipt: 'No receipt',
      status: {
        new: 'New',
        seen: 'Processing',
        shipped: 'Shipped',
        done: 'Done',
        cancelled: 'Cancelled',
        refunded: 'Refunded',
      },
      viewModeList: 'List',
      viewModeReview: 'Order Review',
      orderReviewTitle: 'Step-by-step Order Review',
      orderReviewCounter: (current: number, total: number) => `Order ${current} of ${total}`,
      orderReviewNext: 'Next',
      orderReviewPrev: 'Previous',
      orderReviewRecommendedAction: 'Recommended Action',
      orderReviewConfirmStatus: (id: number, status: string) => `Change order #${id} status to "${status}"?`,
      orderReviewDeliveryDetails: 'Delivery details',
      orderReviewCity: 'City',
      orderReviewWarehouse: 'Warehouse / address',
      orderReviewCustomer: 'Customer',
      orderReviewPhone: 'Phone',
      orderReviewComment: 'Customer comment',
      orderReviewItems: 'Order items',
      orderReviewCopyRequisites: 'Copy payment requisites',
      orderReviewRequisitesCopied: 'Requisites copied',
      orderReviewActionConfirmOrder: 'Confirm Order',
      orderReviewActionMarkShipped: 'Mark as Shipped',
      orderReviewActionMarkDone: 'Mark as Done',
      orderReviewQueueAll: 'All orders',
      orderReviewQueuePending: 'Needs processing',
      orderReviewQueueProcessing: 'In processing',
      statusConfirmPrompt: (id: number, status: string) => `Change status of order #${id} to "${status}"?`,
      refundOrder: 'Refund',
      refundReasonPrompt: 'Refund reason (optional):',
      refundSuccess: 'Order marked as refunded',
      refundFailed: 'Failed to process refund',
      cancelOrder: 'Cancel order',
      questionsText: 'Answer customer questions and save the answer into FAQ for future similar requests.',
      pendingQuestionsCount: (count: number) => `Unanswered questions: ${count}`,
      loadingQuestions: 'Loading questions...',
      noQuestions: 'No unanswered questions',
      noQuestionsText: 'When a customer asks something without a ready answer, it will appear here.',
      userId: 'User',
      answerQuestion: 'Customer answer',
      answerText: 'Answer text',
      sendAnswer: 'Send answer',
      selectQuestion: 'Select a question from the queue',
      questionAnswered: 'Answer saved to FAQ',
      questionAnswerFailed: 'Failed to save answer',
      answerRequired: 'Write an answer',
      storesText: 'Create your shop, update its card, and add basic categories without a heavy backoffice flow.',
      storeEditorTitle: 'Store card',
      storeEditorText: 'Photo, name, slug, and contacts are edited in one compact card.',
      createStoreTitle: 'New store',
      createStoreText: 'Save the basic store card first, then move on to products and categories.',
      createStoreAction: 'Create store',
      cancel: 'Cancel',
      createAnotherStore: 'Another store',
      createAnotherStoreText: 'Open a separate card for a new store when multi-store mode is enabled globally.',
      storeSaved: 'Store saved',
      storeCreated: 'Store created',
      storeActive: 'Active',
      storeInactive: 'Disabled',
      storeActivate: 'Activate store',
      storeDeactivate: 'Deactivate store',
      storeToggled: 'Store status updated',
      staffTitle: 'Staff and sellers',
      staffText: 'Manage admins, managers, and sellers — superadmin only.',
      staffTab: 'Staff',
      sellersTab: 'Sellers',
      addStaffTitle: 'Add staff member',
      staffUserId: 'Telegram user_id',
      staffRole: 'Role',
      staffName: 'Name (for notifications)',
      staffEmail: 'Email (for notifications)',
      addStaffAction: 'Add',
      staffAdded: 'Staff member added',
      removeStaffConfirm: 'Remove this staff member?',
      staffRemoved: 'Staff member removed',
      noStaff: 'No staff members added yet.',
      noSellers: 'No sellers yet.',
      sellerApprove: 'Approve',
      sellerBlock: 'Block',
      sellerUnblock: 'Unblock',
      sellerApproved: 'Seller approved',
      sellerBlocked: 'Seller blocked',
      sellerUnblocked: 'Seller unblocked',
      sellerPendingBadge: 'Pending approval',
      sellerBlockedBadge: 'Blocked',
      sellerApprovedBadge: 'Active',
      roleManager: 'Manager (manager)',
      roleSuperadmin: 'Superadmin (superadmin)',
      roleSeller: 'Seller (seller)',
      validationStaffUserIdRequired: 'Enter a valid Telegram user_id',
      settingsNav: 'Settings',
      settingsTitle: 'Store settings',
      settingsText: 'Technical and financial settings — superadmin only.',
      settingsSaved: 'Settings saved',
      settingsSectionGeneral: 'General',
      maintenanceMode: 'Maintenance mode',
      maintenanceModeText: 'When on, regular Telegram customers see the message below instead of the shop.',
      maintenanceMessage: 'Maintenance message',
      sellerRegistrationEnabled: 'Allow self-serve seller registration',
      minOrderUah: 'Minimum order amount, UAH',
      priceRounding: 'Price rounding (UAH)',
      priceRoundingOff: 'No rounding',
      phonePlaceholderLabel: 'Customer phone placeholder',
      phonePlaceholderText: 'Example phone format shown in customer input fields regardless of country.',
      settingsSectionPayments: 'Payments',
      bankRecipient: 'Recipient (manual payment)',
      bankCard: 'Card number',
      bankIban: 'IBAN',
      bankExtraInfo: 'Extra payment info',
      lodgingDepositPercent: 'Booking deposit (%)',
      customPaymentName: 'Custom payment method name',
      customPaymentDescription: 'Instructions / requisites (e.g. IBAN)',
      paymentMethodsEnabled: 'Payment methods at checkout',
      settingsSectionAuth: 'Website login',
      authProvidersEnabled: 'Login methods on the standalone site (outside Telegram)',
      aiAgentTokenSectionTitle: '🔑 AI Agent Access',
      aiAgentTokenSectionText: 'Generate a short-lived or single-use API token for an AI agent (Antigravity, Claude, Gemini). The agent will make API calls on your behalf.',
      aiAgentTokenTtl: 'Token TTL',
      aiAgentTokenTtl15m: '15 minutes',
      aiAgentTokenTtl1h: '1 hour (60 min)',
      aiAgentTokenTtl6h: '6 hours',
      aiAgentTokenTtl24h: '24 hours (1 day)',
      aiAgentTokenTaskLabel: 'Task name / note (optional)',
      aiAgentTokenTaskPlaceholder: 'e.g. Add new Creed Aventus perfume',
      aiAgentTokenSingleUse: 'Single-use token — expires immediately after first use',
      aiAgentTokenGenerate: '🔑 Generate AI token',
      aiAgentTokenGenerating: 'Generating...',
      aiAgentTokenReady: 'Your AI agent token is ready!',
      aiAgentTokenSingleUseBadge: '⚡ Single-use',
      aiAgentTokenValidTtl: '⏳ Valid for {ttl} min',
      aiAgentTokenCopyPrompt: '📋 Copy AI prompt (1 click)',
      aiAgentTokenCopied: 'Copied! ✅',
      aiAgentTokenError: 'Failed to generate token',
      settingsSectionBackup: 'Backups',
      autoBackupHour: 'Auto-backup hour (0-23, -1 = disabled)',
      gdriveEnabled: 'Upload backups to Google Drive',
      gdriveFolderId: 'Google Drive folder ID',
      gdriveKeepBackups: 'How many backups to keep',
      gdriveUploadSettings: 'Upload settings',
      gdriveUploadPhotos: 'Upload photos',
      emailBackupEnabled: 'Send database backup to Email',
      emailBackupEnabledText: 'Automated delivery of JSONL database archive directly to your email inbox',
      emailBackupAddress: 'Backup recipient email',
      emailBackupAddressPlaceholder: 'admin@example.com',
      emailBackupAddressHint: 'Leave empty to use main orders email',
      emailBackupFrequency: 'Email backup frequency',
      emailBackupFreq1Day: 'Every day',
      emailBackupFreq2Days: 'Every 2 days',
      emailBackupFreq3Days: 'Every 3 days',
      emailBackupFreq7Days: 'Weekly (every 7 days)',
      emailBackupFreq14Days: 'Every 2 weeks',
      emailBackupFreq30Days: 'Monthly (every 30 days)',
      emailBackupFrequencyHint: 'Backup will be emailed no more often than this interval at the auto-backup hour',
      emailBackupLastSent: 'Last email backup sent',
      downloadBackupNow: 'Download DB backup now',
      settingsSectionSeo: 'SEO',
      googleSiteVerification: 'Google Search Console verification code',
      googleSiteVerificationText:
        'Paste the content value from the Google Search Console verification tag ("HTML tag" method): Search Console → Add property → domain property → HTML tag method → copy only the content value, not the whole tag. Once saved, the tag is automatically added to every page of the site.',
      ga4MeasurementId: 'Google Analytics: Measurement ID',
      ga4MeasurementIdText:
        "A G-XXXXXXXXXX ID from Google Analytics 4. Tracking only loads after the visitor consents in the cookie-consent banner — leaving this empty disables both the banner and tracking entirely.",
      metaPixelId: 'Meta / Facebook Pixel ID',
      metaPixelIdText: 'Meta / Facebook Pixel ID for tracking conversions and retargeting on Instagram and Facebook.',
      validationDepositPercentInvalid: 'Deposit percent must be between 0 and 100',
      validationBackupHourInvalid: 'Backup hour must be between -1 and 23',
      dismiss: 'Dismiss',
      settingsSectionMedia: 'Media',
      youtubeChannelId: 'YouTube channel ID',
      youtubeChannelIdText:
        'The channel identifier (starts with "UC..."). Find it: open your channel on YouTube in a browser → "About" → "Share channel" → "Copy channel ID". Once saved, the homepage automatically shows a carousel of the channel\'s latest videos — it refreshes itself, no manual video-list updates needed.',
      settingsSectionEmail: 'Notifications & Email (SMTP)',
      smtpStatusTitle: 'SMTP Server Status',
      smtpConfiguredBadge: 'SMTP is configured and active',
      smtpNotConfiguredBadge: 'SMTP is not configured in .env',
      ordersEmailLabel: 'Email for new order notifications (Manager)',
      ordersEmailPlaceholder: 'orders@mayparfum.com',
      ordersEmailText: 'A copy of every new order will be sent to this address with full items and contact details.',
      customerOrderEmailEnabled: 'Send order confirmation email to customer',
      customerOrderEmailEnabledText: 'If the customer provides an email at checkout, they will receive order details and payment instructions.',
      testEmailTitle: 'Test Email Sending',
      testEmailPlaceholder: 'Enter email to test (e.g. your@email.com)',
      testEmailSend: 'Send Test Email',
      testEmailSending: 'Sending...',
      faqNav: 'FAQ',
      faqTitle: 'Knowledge base (FAQ)',
      faqText: 'Questions and answers the bot shows customers directly, without waiting for a manager.',
      addFaqTitle: 'New question',
      editFaqTitle: 'Edit question',
      faqQuestionUk: 'Question in Ukrainian',
      faqQuestionEn: 'Question in English',
      faqAnswerUk: 'Answer in Ukrainian',
      faqAnswerEn: 'Answer in English',
      faqKeywords: 'Keywords (comma-separated)',
      addFaqAction: 'Add',
      saveFaqAction: 'Save',
      faqAdded: 'Question added',
      faqSaved: 'Question updated',
      faqRemoved: 'Question removed',
      removeFaqConfirm: 'Remove this question?',
      noFaq: 'No questions in the knowledge base yet.',
      searchFaqPlaceholder: 'Search questions or keywords...',
      noFaqFound: 'No questions found matching your search.',
      edit: 'Edit',
      validationFaqQuestionRequired: 'Enter the Ukrainian question',
      validationFaqAnswerRequired: 'Enter the Ukrainian answer',
      analyticsNav: 'Analytics',
      analyticsTitle: 'Store analytics',
      analyticsText: 'Revenue, orders, and customers — managers and superadmin only.',
      analyticsToday: 'Today',
      analyticsWeek: 'Last 7 days',
      analyticsMonth: 'Last 30 days',
      analyticsAllTime: 'All time',
      analyticsOrders: 'Orders',
      analyticsRevenue: 'Revenue',
      analyticsAvgCheck: 'Average check',
      analyticsNewCustomers: 'New customers',
      analyticsReturningCustomers: 'Returning customers',
      analyticsRevenueTrend: '30-day revenue',
      auctionsNav: 'Auctions',
      auctionsTitle: 'Auctions',
      auctionsText: 'Create and manage product auctions.',
      auctionStatusActive: 'Active',
      auctionStatusClosed: 'Closed',
      auctionStatusCancelled: 'Cancelled',
      auctionCurrentPrice: 'Current price',
      auctionStartPrice: 'Start price',
      auctionEndsAt: 'Ends',
      auctionNoWinner: 'No bids yet',
      cancelAuction: 'Cancel auction',
      cancelAuctionConfirm: 'Cancel this auction?',
      auctionCancelled: 'Auction cancelled',
      noAuctions: 'No auctions yet.',
      createAuctionTitle: 'New auction',
      auctionProductId: 'Product ID',
      auctionStartPriceInput: 'Start price, USD',
      auctionMinStep: 'Minimum bid step, USD',
      auctionDurationHours: 'Duration, hours',
      auctionAutoExtend: 'Auto-extend, minutes (0 = off)',
      createAuctionAction: 'Create auction',
      auctionCreated: 'Auction created',
      validationAuctionProductRequired: 'Enter a product ID',
      validationAuctionPriceInvalid: 'Enter a valid start price',
      deliveryNav: 'Delivery',
      deliveryTitle: 'Delivery providers',
      deliveryText: 'Manage the delivery providers available at checkout.',
      deliveryStatusActive: 'Active',
      deliveryStatusInactive: 'Inactive',
      toggleDeliveryProvider: 'Toggle',
      deleteDeliveryProvider: 'Delete',
      deleteDeliveryProviderConfirm: 'Delete this delivery provider?',
      noDeliveryProviders: 'No delivery providers yet.',
      createDeliveryProviderTitle: 'New delivery provider',
      deliveryProviderNameUk: 'Name (Ukrainian)',
      deliveryProviderNameEn: 'Name (English)',
      deliveryProviderIcon: 'Icon (emoji)',
      createDeliveryProviderAction: 'Add provider',
      deliveryProviderCreated: 'Delivery provider added',
      validationDeliveryNameRequired: 'Enter a name in Ukrainian',
      deliveryAutomationTitle: 'Delivery Automation',
      deliveryAutomationText: 'Automatic order status updates and customer notifications (Nova Poshta / Ukrposhta).',
      deliveryAutoDone: 'Auto-complete orders',
      deliveryAutoDoneDesc: 'Automatically mark orders as "Done" when the parcel is received by the customer.',
      deliveryArrivedNotify: 'Arrival notifications',
      deliveryArrivedNotifyDesc: 'Send the customer a Telegram notification when the parcel arrives at the pickup branch or locker.',
      promoCodesNav: 'Promo codes',
      promoCodesTitle: 'Promo codes',
      promoCodesText: 'Create and manage discount codes for checkout.',
      noPromoCodes: 'No promo codes yet.',
      pausePromoCode: 'Pause',
      resumePromoCode: 'Resume',
      deletePromoCode: 'Delete',
      deletePromoCodeConfirm: 'Delete this promo code?',
      createPromoCodeTitle: 'New promo code',
      createPromoCodeHint: 'Set a percentage OR a fixed discount — if both are set, percentage wins.',
      promoCode: 'Code',
      promoDiscountPercent: 'Discount, %',
      promoDiscountFixed: 'Discount, UAH',
      promoMaxUses: 'Max uses (0 = unlimited)',
      createPromoCodeAction: 'Add promo code',
      promoCodeCreated: 'Promo code added',
      validationPromoCodeRequired: 'Enter a promo code',
      reviewsNav: 'Reviews',
      reviewsTitle: 'Review moderation',
      reviewsText: 'A review only appears on the product page once approved here.',
      loadingReviews: 'Loading reviews...',
      noPendingReviews: 'No reviews awaiting moderation.',
      approveReview: 'Approve',
      rejectReview: 'Reject',
      backupNav: 'Backups',
      backupTitle: 'Backups',
      backupText: 'Google Drive connection, on-demand backup, database download and restore.',
      gdriveConnectionTitle: 'Google Drive connection',
      gdriveConnectedAs: 'Connected:',
      gdriveNotConnected: 'Google Drive is not connected.',
      gdriveNotConfigured: 'OAuth is not configured on the server (GOOGLE_OAUTH_CLIENT_ID/SECRET) and there is no service-account credentials file.',
      gdriveConnect: 'Connect Google Drive',
      gdriveDisconnect: 'Disconnect',
      gdriveDisconnected: 'Google Drive disconnected',
      backupActionsTitle: 'Actions',
      backupNowAction: 'Backup to Google Drive now',
      backupNowHint: 'Restoring completely replaces the current database — make sure you are uploading the right file.',
      backupNowSuccess: (n: number) => `Uploaded ${n} file(s) to Google Drive`,
      backupNowPartial: (n: number, failed: string) => `Uploaded ${n} file(s), but failed: ${failed}`,
      backupNowFailed: 'Failed to upload backup to Google Drive',
      backupEmailNowAction: 'Email backup now',
      backupEmailSuccess: (to: string, kb: number) => `Backup (${kb} KB) successfully sent to ${to}`,
      backupEmailFailed: 'Failed to send backup to email',
      loadingAnalytics: 'Loading analytics...',
      loadFailed: 'Failed to load data',
      downloadBackupAction: 'Download backup (.jsonl)',
      restoreAction: 'Restore from file',
      restoreConfirm: 'The current database will be completely replaced with this file\'s contents. Continue?',
      restoreSuccess: (n: number) => `Restored ${n} rows`,
      restoreFailed: 'Failed to restore the database',
      logoFileId: 'Store logo: Telegram file_id',
      contactsUk: 'Contacts in Ukrainian',
      contactsEn: 'Contacts in English',
      storeSlug: 'Store slug',
      noStores: 'No store yet',
      noStoresText: 'Create the basic store card first so you can move straight to products and categories.',
      categoryCreateTitle: 'Store categories',
      categoryCreateText: 'Categories are created separately and must stay unique by name.',
      categoryCreated: 'Category created',
      categoryNameTaken: 'A category with that name already exists',
      createCategoryAction: 'Create category',
      validationStoreLogoRequired: 'Add the store logo file_id',
      validationStoreSlugRequired: 'Enter the store slug',
      validationStoreNameRequired: 'Enter the Ukrainian store name',
      selectProduct: 'Select a product',
      selectProductText: 'The safe editor for the selected product opens on the right.',
      createProduct: 'New product',
      createProductText:
        'Create the product with the minimum set first: name and category. Everything else is edited on the product page.',
      createProductAction: 'Create product',
      saveChanges: 'Save changes',
      saving: 'Saving...',
      productCreated: 'Product created',
      productSaved: 'Changes saved',
      productDeleted: 'Product deleted',
      saveFailed: 'Failed to save changes',
      deleteFailed: 'Failed to delete',
      deleteProduct: 'Delete product',
      deleteProductConfirm: 'Delete this product?',
      itemRemoved: 'Item removed',
      productStore: 'Product store',
      noStoreScope: 'No dedicated store',
      productCategory: 'Category',
      selectCategory: 'Select a category',
      nameSingle: 'Name',
      nameUk: 'Ukrainian name',
      nameEn: 'English name',
      descriptionSingle: 'Description',
      descriptionUk: 'Ukrainian description',
      descriptionEn: 'English description',
      descriptionTab: 'Description',
      previousStep: 'Back',
      nextStep: 'Next',
      editSection: 'Edit',
      markdown: {
        source: 'Markdown',
        preview: 'Preview',
        empty: 'The description preview appears here while you type.',
        bold: 'Bold',
        italic: 'Italic',
        list: 'List',
        link: 'Link',
      },
      priceUsd: 'Price in USD',
      productionDays: 'Production days',
      readyToShip: 'Ready to ship',
      basicInfoTitle: 'Basic info',
      basicInfoText: 'Names, descriptions, and category. This is the main product card for content editing.',
      productSlug: 'URL Slug',
      productSlugHelp: 'Direct link to product: /product/slug or /app/catalog/slug',
      commerceTitle: 'Price and availability',
      commerceText: 'A separate block for pricing, stock status, and made-to-order timing.',
      mediaTitle: 'Photos and video',
      mediaText: 'Primary photo, gallery, and YouTube are split out so the mobile editor stays calm and easy to scan.',
      mediaSummaryNoVideo: 'No YouTube',
      telegramUploadTitle: 'Fast photo flow via Telegram',
      telegramUploadText:
        'If Telegram is easier for you, open the bot, add a photo or image URL there, then come back here and refresh the product card.',
      openTelegramBot: 'Open bot',
      refreshProductCard: 'Refresh card',
      noPrimaryPhoto: 'No photo',
      youtubeLink: 'YouTube link',
      primaryPhotoFileId: 'Primary photo: Telegram file_id',
      primaryPhotoSourceUrl: 'Primary photo: source URL',
      galleryTitle: 'Gallery',
      galleryText: 'Add gallery photos via file_id. The primary photo is edited above.',
      galleryPhotoFileId: 'Gallery photo: Telegram file_id',
      galleryPhotoSourceUrl: 'Gallery photo: source URL',
      addGalleryPhoto: 'Add gallery photo',
      photoAdded: 'Photo added',
      photoReordered: 'Photo order updated',
      primaryPhotoLabel: 'Primary photo',
      galleryPhotoLabel: 'Gallery photo',
      makePrimaryPhoto: 'Make primary',
      movePhotoUp: 'Move up',
      movePhotoDown: 'Move down',
      deletePhotoConfirm: 'Delete this photo?',
      optionsTitle: 'Options and variants',
      optionsText:
        'Option groups and variants are created separately so the browser editor can stay lightweight and predictable.',
      specsTitle: 'Characteristics',
      specsText: 'Product facts used by the product card, filters, quiz, and comparison.',
      specsSummary: 'editable characteristics',
      specNameSingle: 'Characteristic',
      specNameUk: 'Characteristic in Ukrainian',
      specNameEn: 'Characteristic in English',
      specValueSingle: 'Value',
      specValueUk: 'Value in Ukrainian',
      specValueEn: 'Value in English',
      sortOrder: 'Sort order',
      addSpec: 'Add characteristic',
      saveSpec: 'Save characteristic',
      specAdded: 'Characteristic added',
      specSaved: 'Characteristic saved',
      deleteSpecConfirm: 'Delete this characteristic?',
      kitTabTitle: 'Kit',
      kitTabText: 'Turn this product into a bundle of other products (e.g. an aromabox) — it keeps its own price; the contents only affect stock deduction.',
      kitIsKitBadge: 'This is a kit',
      kitNoItems: 'No products added to this kit yet.',
      kitAddItemTitle: 'Add a product to the kit',
      kitSearchPlaceholder: 'Start typing a product name…',
      kitNoSearchResults: 'Nothing found.',
      kitAddAction: 'Add',
      kitSearchScopeHint: "Searches the first 50 products in this store.",
      kitQuantity: 'Quantity',
      kitSaveAction: 'Save kit contents',
      kitSaved: 'Kit contents saved',
      addOption: 'Add option',
      optionAdded: 'Option added',
      optionNameSingle: 'Option name',
      optionNameUk: 'Option name in Ukrainian',
      optionNameEn: 'Option name in English',
      deleteOptionConfirm: 'Delete this option with all its variants?',
      addVariant: 'Add variant',
      variantAdded: 'Variant added',
      variantNameSingle: 'Variant name',
      variantNameUk: 'Variant name in Ukrainian',
      variantNameEn: 'Variant name in English',
      variantPriceDiff: 'USD price diff',
      variantPhotoFileId: 'Variant photo file_id',
      defaultVariant: 'Default variant',
      deleteVariantConfirm: 'Delete this variant?',
      remove: 'Remove',
      variantStock: 'Stock',
      variantStockUnlimited: 'Untracked',
      saveStock: 'Save',
      stockSaved: 'Stock updated',
      validationCategoryRequired: 'Select a category',
      validationNameRequired: 'Enter the Ukrainian name',
      validationPriceInvalid: 'Enter a valid USD price',
      validationYoutubeInvalid: 'Enter a valid YouTube link',
      validationDaysInvalid: 'Production days must be an integer from 0 to 365',
      validationPhotoRequired: 'Enter a Telegram file_id for the photo',
      validationOptionRequired: 'Enter the Ukrainian option name',
      validationVariantRequired: 'Enter the Ukrainian variant name',
      validationVariantPriceInvalid: 'Enter a valid variant price diff',
      validationVariantStockInvalid: 'Stock must be a non-negative whole number',
      validationSpecNameRequired: 'Enter the Ukrainian characteristic name',
      validationSpecValueRequired: 'Enter the Ukrainian characteristic value',
      validationSpecSortInvalid: 'Sort order must be a number from 0 to 365',
      noAccessTitle: 'No admin access',
      noAccessText: 'This separate app is shown only to sellers, managers, and superadmins.',
      loginRequiredTitle: 'Login required',
      loginRequiredText: 'Sign in to the shop first, then open admin again.',
      openLogin: 'Open login',
      serverErrorTitle: 'Server error',
      serverErrorText: 'Could not connect to the server or an internal error occurred. Please try again.',
      retry: 'Try again',
      fillWithAi: '✨ Fill with AI',
      aiModalTitle: 'Paste product description or raw text for AI parsing',
      aiModalPlaceholder: 'Paste text from supplier site, fragrance notes, name or price...',
      aiParseAction: '🪄 Parse and fill',
      aiParsing: 'Parsing...',
      aiParseError: 'Failed to parse text with AI',
      closeAction: 'Close',
      specsTab: 'Specifications',
      specsSubtitle: 'Set fragrance notes, concentration, scent family, and other attributes',
      specsEmpty: 'This product has no specifications yet.',
      specCode: 'Specification code',
      specCodeSlug: 'Specification code (slug)',
      addSpecTitle: 'Add new specification',
      addSpecSubtitle: 'Choose a known preset or create a custom attribute',
      specPresetsLabel: 'Quick presets from catalog:',
      specCachedValuesLabel: 'Existing values in cache:',
      addVariantGroupTitle: 'Create new option group (e.g., Volume)',
      addVariantToOptionTitle: 'Add option variant',
      addGalleryPhotoTitle: 'Add photo to gallery',
      seoTab: 'SEO / Google Optimization',
      seoTagsTitle: 'SEO tag configuration',
      seoTagsSubtitle: 'Set unique titles and descriptions for search engines like Google',
      metaTitleUk: 'Meta Title (UK) — Google Title',
      metaTitleEn: 'Meta Title (EN)',
      metaDescriptionUk: 'Meta Description (UK) — Search snippet description',
      metaDescriptionEn: 'Meta Description (EN)',
      seoAuditTitle: 'SEO / Google Audit',
      seoAuditSubtitle: 'Google preview and product optimization audit',
    },
  },
  ru: {
    common: {
      actionFailed: 'Не удалось сохранить изменения. Попробуйте ещё раз.',
      loading: 'Загрузка...',
      error: 'Ошибка загрузки',
      total: 'Итого',
      paid: 'Оплачено',
      unpaid: 'Ожидает оплаты',
      consentText: 'Мы используем аналитику, чтобы улучшать сайт. Продолжая, вы соглашаетесь.',
      consentAccept: 'Согласиться',
      consentDecline: 'Отклонить',
      watchOnYoutube: 'Смотреть на YouTube',
      close: 'Закрыть',
    },
    fopModal: {
      title: 'Реквизиты для оплаты (ФОП / IBAN)',
      subtitle: 'Официальная оплата через любой банк Украины',
      loading: 'Загрузка реквизитов...',
      notConfigured: 'Реквизиты для оплаты пока не настроены.',
      recipient: 'Получатель (ФОП / Предприятие)',
      amount: 'Сумма к оплате',
      purpose: 'Назначение платежа',
      bankCard: 'Номер банковской карты',
      extraInfo: 'Дополнительная информация / Банк',
      scanQrHint: 'Отсканируйте QR-код в приложении вашего банка для быстрой оплаты',
      copyIban: 'Скопировать IBAN',
      copied: 'Скопировано!',
    },
    nav: {
      home: 'Главная',
      catalog: 'Каталог',
      quiz: 'Подбор',
      services: 'Услуги',
      auctions: 'Аукционы',
      cart: 'Корзина',
      profile: 'Профиль',
      stories: 'Статьи',
      wishlist: 'Избранное',
      brands: 'Бренды',
    },
    brands: {
      officialBrand: 'Официальный бренд',
      outOfStock: 'Нет в наличии',
      title: 'Бренды',
      allBrands: 'Все бренды',
      subtitle: 'Оригинальная нишевая и селективная парфюмерия от мировых домов',
      searchPlaceholder: 'Поиск бренда...',
      allLetters: 'Все',
      productCount: (count: number) => `${count} товар${count === 1 ? '' : count >= 2 && count <= 4 ? 'а' : 'ов'}`,
      noBrandsFound: 'Брендов по вашему запросу не найдено',
      noProductsFound: 'У этого бренда пока нет товаров в наличии',
      backToBrands: 'Все бренды',
      allCategories: 'Все категории',
      allGenders: 'Все полы',
      viewProducts: 'Смотреть товары',
      filterCategory: 'Категория',
      filterGender: 'Пол',
      sortBy: 'Сортировать',
      sortPopular: 'По популярности',
      sortPriceAsc: 'От дешевых к дорогим',
      sortPriceDesc: 'От дорогих к дешевым',
      sortNewest: 'Новинки',
      priceFrom: 'от',
      aboutBrand: 'О бренде',
      readMore: 'Читать далее',
      showLess: 'Свернуть',
      viewAllInCatalog: (count: number) => `Смотреть все товары в каталоге (${count})`,
    },
    specs: {
      title: 'Характеристика',
      allSpecs: 'Все характеристики',
      backToCatalog: 'В каталог',
      productsWithSpec: (name: string) => `Товары с характеристикой «${name}»`,
      productCount: (count: number) => `${count} товар${count === 1 ? '' : count >= 2 && count <= 4 ? 'а' : 'ов'}`,
      viewAllInCatalog: (count?: number) => count && count > 0 ? `Смотреть все товары в каталоге (${count})` : 'Смотреть все в каталоге',
      readMore: 'Читать далее',
      showLess: 'Свернуть',
      noProducts: 'Сейчас нет товаров с этой характеристикой',
      aboutAttribute: 'О характеристике',
      priceFrom: 'от',
      sortBy: 'Сортировать',
      sortPriceAsc: 'От дешевых к дорогим',
      sortPriceDesc: 'От дорогих к дешевым',
      sortNewest: 'Новинки',
    },
    home: {

      shopNow: 'В каталог',
      categoriesTitle: 'Категории',
      newProductsTitle: 'Новинки',
      quizBannerTitle: 'Подбери свой аромат',
      quizBannerCta: 'Пройти тест',
      mayparfumEyebrow: 'Нишевая парфюмерия и распив',
      mayparfumTitle: 'MAY PARFUM',
      mayparfumSubtitle:
        'Оригинальные ароматы, деканты и редкие флаконы для тех, кто хочет сперва почувствовать историю на коже.',
      mayparfumPrimary: 'Выбрать аромат',
      mayparfumSecondary: 'Парфюмерная культура',
      mayparfumTrust: ['Оригинальность', 'Распив', 'Быстрая отправка'] as string[],
      mayparfumWelcomeEyebrow: 'Добро пожаловать в мир ароматов',
      mayparfumWelcomeTitle: 'Откройте новые горизонты парфюмерии',
      mayparfumWelcomeBody:
        'MAY PARFUM — пространство нишевой, селективной, авторской и артизанальной парфюмерии. Здесь можно найти аромат под настроение, сезон или важное событие.',
      mayparfumBrandsTitle: 'Бренды в подборках',
      mayparfumChannelTitle: 'Актуальные ароматы из телеграм-канала @mayparfum_nspl',
      mayparfumStoriesTitle: 'Парфюмерная культура',
      mayparfumStoriesSubtitle: 'Короткие материалы, которые помогут выбирать аромат внимательнее.',
      mayparfumCatalogHint: 'Смотрите новинки, подборки и ароматы под настроение.',
      mayparfumHighlights: [
        {
          title: 'Персонализированный выбор',
          body: 'Подборки по характеру, сезону, событию и любимым нотам.',
        },
        {
          title: 'Аромабоксы',
          body: 'Удобный формат для знакомства с несколькими ароматами перед флаконом.',
        },
        {
          title: 'Парфюмерная культура',
          body: 'Статьи и обзоры, помогающие лучше понимать композиции.',
        },
      ] as { title: string; body: string }[],
    },
    stories: {
      fragranceQuiz: 'Подбор аромата',
      storiesCultureTitle: 'ПАРФЮМЕРНАЯ КУЛЬТУРА',
      storiesCultureSubtitle: 'Парфюмерный гид и база знаний',
      storiesCultureDescription: 'Все о нишевых ароматах, декантах, концентрациях, стойкости и правильном нанесении.',
      searchPlaceholder: 'Поиск среди статей и гайдов...',
      noArticlesFound: 'Статей по запросу не найдено.',
      readGuide: 'Читать гайд',
    },
    quizNav: {
      title: 'Подбор товара',
      step: 'Вопрос {current} из {total}',
      next: 'Далее',
      back: 'Назад',
      viewResults: 'Посмотреть варианты',
      startOver: 'Начать заново',
      foundCount: 'Найдено: {count}',
      noMatches: 'Ничего не найдено — попробуйте убрать несколько ответов',
      results: 'Результаты',
      profileTitle: 'Ваш ольфакторный профиль',
      profileSub: 'Создано на основе ваших предпочтений и выбранных аккордов',
      copyProfile: 'Скопировать профиль',
      copied: 'Скопировано!',
      shareProfile: 'Поделиться',
      tweakAnswers: 'Изменить ответы',
      retakeQuiz: 'Пройти ещё раз',
      matchReason: 'Подходит под ваш выбор',
      whyMatch: 'Рекомендованные ароматы по вашему профилю',
      matchedAccords: 'Совпадения',
    },
    page: {
      notFound: 'Страница не найдена',
    },
    catalog: {
      fragranceCatalog: 'Каталог ароматов',
      fragranceCatalogShop: (shop: string) => `Каталог ароматов — ${shop}`,
      fromPrice: 'от',
      perNight: '/ ночь',
      book: 'Забронировать',
      details: 'Характеристики',
      title: 'Каталог',
      loading: 'Загрузка...',
      search: 'Поиск товаров...',
      all: 'Все',
      allStores: 'Все магазины',
      empty: 'Товары не найдены',
      categoriesTitle: 'Категории',
      wishlist: 'Избранное',
      mto: 'Под заказ',
      addToCart: 'В корзину',
      adding: '...',
      outOfStock: 'Нет в наличии',
      addFail: 'Не удалось добавить в корзину. Попробуйте еще раз.',
      filterBtn: 'Фильтр',
      resultCount: (count: number) => `${count} товар${count === 1 ? '' : count >= 2 && count <= 4 ? 'а' : 'ов'}`,
      filters: {
        title: 'Фильтры',
        legend: 'Нажмите: показать → скрыть → сбросить',
        selected: 'Выбрано',
        searchPlaceholder: 'Поиск...',
        noMatches: 'Ничего не найдено',
        showMore: 'Показать еще',
        showLess: 'Свернуть',
        priceRange: 'Цена, UAH',
        priceRangeWithCurrency: (currency: string) => `Цена, ${currency}`,
        priceMin: 'От',
        priceMax: 'До',
        variant: 'Вариант',
        variantAny: 'Не важно',
        clear: 'Сбросить фильтры',
        apply: 'Показать результаты',
      },
    },
    cart: {
      title: 'Корзина',
      decrease: 'Уменьшить количество',
      increase: 'Увеличить количество',
      remove: 'Удалить',
      loading: 'Загрузка...',
      empty: 'Корзина пуста',
      checkout: (uah: number) => `Оформить — ${uah} UAH`,
      clear: 'Очистить корзину',
      total: 'Итого',
      mtoSingle: 'Под заказ',
      mtoEta: (d: number) => `🕒 Ожидаемый срок изготовления: ~${d} дн.`,
      mtoGeneric: '🕒 Некоторые товары под заказ',
    },
    checkout: {
      goToCatalog: 'Перейти в каталог',
      backToCart: 'Назад в корзину',
      addItems: '+ Добавить товары',
      fopIbanTitle: 'Официальный счет ФОП (IBAN)',
      viewFopRequisites: 'Реквизиты ФОП',
      fopPaymentInfo: 'Вы сможете скопировать IBAN и оплатить заказ в Monobank, Приват24 или другом приложении банка сразу или после оформления.',
      manualPaymentInfo: 'Детали оплаты будут согласованы менеджером при подтверждении заказа.',
      title: 'Оформление',
      loading: 'Загрузка...',
      name: 'Имя',
      contact: 'Номер телефона',
      deliveryType: 'Тип доставки',
      city: 'Город',
      delivery: 'Доставка / отделение',
      comment: 'Комментарий',
      promo: 'Промокод',
      payment: 'Способ оплаты',
      securePayment: 'Безопасная оплата',
      submit: (uah: number) => `Заказать — ${uah} UAH`,
      submitting: 'Оформление...',
      emptyCart: 'Корзина пуста',
      deliveryTypes: [
        { value: '', label: 'Не выбрано' },
        { value: 'nova_poshta', label: 'Новая Почта' },
        { value: 'ukrposhta', label: 'Укрпочта' },
      ] as { value: string; label: string }[],
      errors: {
        name_required: 'Введите имя',
        contact_required: 'Введите номер телефона',
        city_required: 'Введите город',
        delivery_required: 'Введите отделение или адрес',
        contact_invalid: 'Введите корректный номер телефона (например: +380501234567)',
        promo_invalid: 'Промокод недействителен или истек',
      },
      applyPromo: 'Применить',
      promoApplied: 'Промокод применен',
      discount: 'Скидка',
    },
    orders: {
      title: 'Мои заказы',
      loading: 'Загрузка...',
      empty: 'Заказов еще нет',
      paid: 'Оплачено',
      unpaid: 'Ожидает оплаты',
      payOnline: 'Оплатить онлайн',
      payOnlineAmount: (amount: number) => `💳 Оплатить онлайн (${amount} UAH)`,
      paying: 'Переход к оплате...',
      payFailed: 'Не удалось создать платеж. Попробуйте позже.',
      codNote: '📦 Оплата при получении (наложенный платеж)',
      total: 'Итого',
      reorder: '🔄 Заказать еще',
      reordering: '...',
      reorderFail: '❌ Недоступно',
      delete: 'Удалить',
      tracking: 'ТТН',
      deliveryStatus: 'Статус доставки',
      deliveryEstimated: 'Ориентировочная доставка',
      deliveryInTransit: 'В пути',
      deliveryArrived: 'Прибыло в отделение',
      deliveryReceived: 'Получено',
      trackNovaPoshta: 'Отследить на Новой Почте',
      trackUkrposhta: 'Отследить на Укрпочте',
      copy: 'Копировать',
      copied: 'Скопировано',
      deleteConfirm: (id: number) =>
        `Удалить заявку #${id}? Это возможно только пока магазин не принял ее в обработку.`,
      deleteSeenError:
        'Магазин уже принял заказ в обработку — обратитесь к нам для отмены.',
      status: {
        new: 'Новый',
        seen: 'В обработке',
        shipped: 'Отправлен',
        done: 'Выполнен',
        cancelled: 'Отменен',
        refunded: 'Возвращен',
      },
      changePayment: 'Сменить способ оплаты',
      paymentMethod: 'Способ оплаты',
      paymentMethodUpdated: 'Способ оплаты изменен',
      buyAgain: 'Купить снова',
      addMore: 'Добавить в корзину',
      itemAddedToCart: 'Товар добавлен в корзину',
      orderSupport: 'Поддержка по заказу',
      copyOrderDetails: 'Скопировать детали',
      orderDetailsCopied: 'Детали заказа скопированы',
      timeline: {
        new: 'Принят',
        seen: 'В обработке',
        shipped: 'Отправлен',
        done: 'Получен',
      },
      paymentMethods: {
        liqpay: 'LiqPay (Карта / Apple Pay / Google Pay)',
        monopay: 'Monobank (MonoPay / Карта)',
        stripe: 'Stripe (Apple Pay / Карта / BLIK)',
        sandbox: 'Тестовая оплата (Sandbox)',
        manual: 'По реквизитам (IBAN / ФОП)',
        cod: 'Наложенный платеж (при получении)',
        telegram: 'Telegram Stars',
        pay_on_site: 'Оплата на месте',
      },
      sandboxPayment: {
        title: 'Тестовая оплата (Sandbox)',
        subtitle: 'Симулятор платежного шлюза для тестирования',
        orderNumber: 'Заказ #',
        amount: 'Сумма к оплате',
        selectMethod: 'Выберите тестовый метод оплаты',
        card: 'Тестовая карта (Visa / Mastercard)',
        applePay: 'Apple Pay (Симуляция)',
        blik: 'BLIK (Тестовый код: 123456 / 777123)',
        cardHint: 'Используется виртуальная тестовая карта 4242 4242 4242 4242',
        blikHint: 'Для тестирования BLIK подойдет любой 6-значный код (например, 123456 или 777123)',
        simulateSuccess: '✅ Подтвердить тестовую оплату (Success)',
        simulateFail: '❌ Симулировать отклонение (Decline)',
        processing: 'Обработка тестового платежа...',
        successTitle: 'Оплата успешно завершена!',
        successText: 'Заказ отмечен как оплаченный, запущена фискализация и уведомления.',
        failedTitle: 'Оплата отклонена',
        failedText: 'Симулятор отклонил тестовую транзакцию. Вы можете попробовать снова.',
        backToOrders: 'Перейти к моим заказам',
        tryAgain: 'Попробовать снова',
      },
    },
    product: {
      fastDeliveryTitle: 'Быстрая доставка по Украине',
      fastDeliveryText: 'Новая Почта (отделения, почтоматы, курьер), Укрпочта. Отправка 1-2 дня.',
      officialFopTitle: 'Официальная оплата по реквизитам ФОП (IBAN)',
      officialFopText: 'Оплата на официальный счет IBAN (Monobank, Приват24), онлайн картой или при получении.',
      kitContents: 'Состав набора:',
      spraysEstimate: (sprays: number) => `≈ ${sprays} расп.`,
      free: 'Бесплатно',
      back: 'Назад в каталог',
      notFound: 'Товар не найден',
      addToCart: 'Добавить в корзину',
      adding: 'Добавляем...',
      added: 'В корзине',
      madeToOrder: 'Изготавливаем под заказ',
      watchVideo: 'Смотреть видео',
      share: 'Поделиться',
      addToWishlist: 'В избранное',
      inWishlist: 'В избранном',
      description: 'Описание',
      attributes: 'Характеристики',
      filterByAttribute: 'Показать похожие',
      outOfStock: 'Нет в наличии',
      shareSuccess: 'Ссылка скопирована',
      shareError: 'Не удалось поделиться',
      addFail: 'Не удалось добавить в корзину. Попробуйте еще раз.',
      relatedTitle: 'Вам также может понравиться',
      noReviewsYet: 'еще нет отзывов',
      reviewsCount: (n: number) => `${n} ${n === 1 ? 'отзыв' : n < 5 ? 'отзыва' : 'отзывов'}`,
      writeReview: 'Написать отзыв',
      reviewCommentPlaceholder: 'Ваш отзыв (необязательно)',
      reviewSubmit: 'Отправить',
      reviewSubmitting: 'Отправка...',
      reviewCancel: 'Отмена',
      reviewSubmitted: 'Спасибо! Отзыв появится после проверки модератором.',
      reviewSubmitFailed: 'Не удалось отправить отзыв. Попробуйте еще раз.',
    },
    wishlist: {
      title: 'Список желаний',
      loading: 'Загрузка...',
      empty: 'Пока нет сохраненных товаров',
      clear: 'Очистить',
      addToCart: 'В корзину',
      adding: '...',
      outOfStock: 'Нет',
      openCatalog: 'Перейти в каталог',
      addFail: 'Не удалось добавить в корзину. Попробуйте еще раз.',
    },
    auctions: {
      title: 'Аукционы',
      loading: 'Загрузка...',
      empty: 'Активных аукционов нет',
      disabled: 'Аукционы сейчас отключены',
      bids: 'ставок',
      ended: 'Завершен',
    },
    auction: {
      back: 'К аукционам',
      notFound: 'Не найдено',
      disabled: 'Аукционы сейчас отключены',
      bids: 'ставок',
      ended: 'Завершен',
      winning: 'Вы лидируете!',
      recentBids: 'Последние ставки',
      bidder: 'Участник',
      you: 'Вы',
    },
    services: {
      title: 'Услуги',
      empty: 'Услуг пока нет',
      provider: 'Исполнитель',
      date: 'День',
      time: 'Время',
      noSlots: 'На этот день нет свободных слотов',
      notes: 'Комментарий к записи',
      add: 'Добавить в корзину',
      adding: 'Добавляется...',
      slotTaken: 'Это время уже занято. Выберите другой слот.',
      calendarConflict:
        '⏳ Добавлено в корзину. Запись требует подтверждения — у исполнителя есть другое мероприятие на это время.',
      min: 'мин',
      back: '← Назад',
    },
    bookings: {
      title: 'Мои записи',
      empty: 'Записей еще нет',
      paid: 'Оплачено',
      unpaid: 'Ожидает оплаты',
      filters: {
        all: 'Все',
        active: 'Активные',
        past: 'Прошедшие',
        cancelled: 'Отмененные',
      },
      anyDay: 'Любой день',
      service: 'Услуга',
      provider: 'Исполнитель',
      contact: 'Контакт',
      created: 'Создано',
      notes: 'Комментарий',
      addToCalendar: 'Добавить в календарь',
      cancel: 'Отменить',
      cancelling: '...',
      confirmCancel: (id: number) => `Отменить запись #${id}?`,
      calendarPending: '⚡ Ожидает подтверждения из-за конфликта в календаре',
      cancellationReason: 'Причина отмены',
      status: {
        pending: 'Ожидает',
        confirmed: 'Подтверждено',
        cancelled: 'Отменено',
        done: 'Выполнено',
        no_show: 'Не пришел',
      },
    },
    profile: {
      title: 'Профиль',
      subtitle: 'Управляйте своими данными и настраивайте нужные разделы',
      error: 'Ошибка загрузки',
      editProfile: 'Редактировать профиль',
      editProfileHint: 'Имя, контакты, язык и сохраненная доставка',
      myOrders: 'Мои заказы',
      myOrdersHint: 'История, повторный заказ и удаление',
      myBookings: 'Мои записи',
      myBookingsHint: 'Активные записи и отмена',
      createStore: 'Стать продавцом',
      createStoreHint: 'Создайте свой магазин и управляйте товарами отдельно',
      becomingSeller: 'Открываем доступ...',
      openAdmin: 'Открыть админку',
      openAdminHint: 'Отдельное приложение для продавца или менеджера',
      login: 'Войти',
      loginHint: 'Войдите, чтобы видеть заказы, бронирования и сохраненные данные',
      logout: 'Выйти',
      logoutHint: 'Завершить текущую сессию',
      loggingOut: 'Выходим...',
      guestName: 'Гость',
      guestContact: 'Войдите, чтобы управлять профилем',
      nameFallback: 'Без имени',
      noContact: 'Добавьте телефон или email',
      noDelivery: 'Доставка еще не настроена',
      interfaceLanguage: 'Язык интерфейса',
      languageLabels: { uk: 'Українська', en: 'English', ru: 'Русский' } as Record<string, string>,
      deliveryLabels: { nova_poshta: 'Новая Почта', ukrposhta: 'Укрпочта' } as Record<
        string,
        string
      >,
      infoTitle: 'Информация',
      myActivity: 'Моя активность',
      myWishlist: 'Список желаний',
      myWishlistHint: 'Сохранённые товары и быстрый доступ',
      perfumeProfile: 'Ольфакторный профиль',
      perfumeProfileHint: 'Ваш персональный парфюмерный архетип',
      perfumeQuizCta: 'Подобрать свой аромат',
      perfumeQuizCtaHint: 'Пройдите тест для персонального подбора ароматов',
      guidesTitle: 'Полезные материалы',
      perfumeGuides: 'Парфюмерный гид и статьи',
      perfumeGuidesHint: '7 гайдов о нишевых ароматах, декантах и стойкости',
      articlesAndGuides: 'Статьи и инструкции',
      articlesAndGuidesHint: (count: number) =>
        count > 0 ? `${count} полезных материалов и инструкций` : 'Полезные материалы и инструкции',
      helpAndRules: 'Сервис и правила',
      supportTelegram: 'Поддержка в Telegram',
      supportTelegramHint: 'Написать менеджеру магазина',
      storeInfoAndRules: 'О магазине и условия',
      storeInfoAndRulesHint: 'Доставка, оплата, условия конфиденциальности',
      accountSettings: 'Настройки',
      referralTitle: 'Пригласите друга',
      referralHint: (percent: number) =>
        `Поделитесь кодом — новый покупатель получит ${percent}% скидки, а вы — бонус на следующий заказ.`,
      referralCopy: 'Скопировать код',
      referralShare: 'Поделиться',
      referralCopied: 'Код скопирован',
      referralShareText: (code: string, percent: number, shopName: string) =>
        `Скидка ${percent}% в ${shopName || 'нашем магазине'} по промокоду ${code}!`,
    },
    profileEdit: {
      title: 'Редактировать профиль',
      back: 'Назад в профиль',
      name: 'Имя',
      email: 'Email',
      phone: 'Телефон',
      delivery: 'Сохраненная доставка',
      deliveryType: 'Тип доставки',
      city: 'Город',
      warehouse: 'Отделение',
      save: 'Сохранить',
      saving: 'Сохранение...',
      saved: '✅ Сохранено',
      logout: 'Выйти',
      language: 'Язык интерфейса',
      languageUk: '🇺🇦 Українська',
      languageEn: '🇬🇧 English',
      error: 'Ошибка загрузки',
      emailHint: 'Для входа через email и получения чеков',
      phoneHint: 'Для связи по заказам и доставке',
      deliveryHint: 'Будет подставлено автоматически при оформлении заказа',
      phonePlaceholder: '+380...',
      cityPlaceholder: 'напр. Киев',
      warehousePlaceholder: 'напр. Отделение №5',
      deliveryTypes: [
        { value: '', label: 'Не выбрано' },
        { value: 'nova_poshta', label: 'Новая Почта' },
        { value: 'ukrposhta', label: 'Укрпочта' },
      ] as { value: string; label: string }[],
    },
    login: {
      title: 'Войти',
      loading: 'Загрузка...',
      subtitle: 'Выберите удобный способ входа. Каждый вариант ведет в тот же аккаунт.',
      telegramTitle: 'Telegram',
      telegramWidget: 'Войти через Telegram',
      telegramHint: 'Быстрый вход через Telegram-аккаунт в браузере',
      googleTitle: 'Google',
      google: 'Войти через Google',
      googleHint: 'Быстрый вход через ваш Google-аккаунт',
      emailTitle: 'Email',
      emailHint: 'Получите magic link на почту без пароля',
      emailPlaceholder: 'ваш@email.com',
      emailBtn: 'Отправить ссылку',
      emailSending: 'Отправка...',
      emailSent: 'Ссылка отправлена — проверьте почту.',
      emailResend: 'Отправить еще раз',
      emailError: 'Ошибка. Попробуйте еще раз.',
      openTelegram: 'Открыть магазин в Telegram',
      openTelegramHint: 'Переход в Telegram',
      noProviders: 'Вход временно недоступен.',
      guest: 'Продолжить как гость',
      guestHint: 'Можно смотреть каталог без профиля, а войти в аккаунт позже.',
      guestError: 'Не удалось открыть гостевой доступ.',
    },
    novaPoshta: {
      cityPlaceholder: 'Начните вводить город',
      cityHint: 'Выберите город из списка, чтобы загрузить отделения',
      warehousePlaceholder: 'Начните вводить номер или адрес отделения',
      warehouseHint: 'Ищите отделение по номеру или тексту адреса',
      loading: 'Загрузка...',
      notConfigured: 'Поиск Новой Почты недоступен — можно ввести вручную.',
      noCities: 'Город не найден',
      noWarehouses: 'Отделения не найдены',
      selectedCity: 'Выбранный город',
      selectedWarehouse: 'Выбранное отделение',
      changeCity: 'Изменить город',
      changeWarehouse: 'Изменить отделение',
    },
    ukrposhta: {
      byIndexTab: 'По индексу',
      byCityTab: 'По городу',
      indexPlaceholder: '5-значный индекс (напр. 01001)',
      indexHint: 'Введите 5 цифр почтового индекса',
      cityPlaceholder: 'Начните вводить город',
      cityHint: 'Выберите город из списка',
      officePlaceholder: 'Выберите отделение Укрпочты',
      officeHint: 'Ищите по индексу или адресу',
      loading: 'Загрузка...',
      notConfigured: 'Поиск Укрпочты недоступен — можно ввести вручную.',
      noOffices: 'Отделения не найдены',
      noCities: 'Город не найден',
      selectedCity: 'Выбранный город',
      selectedOffice: 'Выбранное отделение',
      changeCity: 'Изменить город',
      changeOffice: 'Изменить отделение',
    },
    admin: {

      noOrdersText: 'В этом магазине пока нет заказов или выбранные фильтры не дали результатов.',
      orderUpdated: 'Заказ обновлен',
      orderUpdateFailed: 'Не удалось обновить заказ',
      orderPaidMarked: 'Заказ отмечен как оплаченный',
      orderArchived: 'Заказ перенесен в архив',
      orderRestored: 'Заказ восстановлен из архива',
      orderDeletedForever: 'Заказ навсегда удален',
      refiscalizeQueued: 'Запрос на повторную фискализацию отправлен',
      npCreateWaybill: 'Создать накладную Новой Почты',
      npCityPlaceholder: 'Поиск города (напр. Киев)...',
      npWarehousePlaceholder: 'Поиск отделения (напр. 15)...',
      npChangeCity: 'Изменить город',
      npChangeWarehouse: 'Изменить отделение',
      npRecipientName: 'ФИО получателя',
      npRecipientPhone: 'Телефон (+380...)',
      npWeightKg: 'Вес (кг)',
      npSubmit: 'Сформировать ТТН',
      npCancel: 'Отмена',
      npCreateFailed: 'Не удалось создать накладную Новой Почты',
      npWaybillCreated: 'Накладная создана',
      tracking: 'ТТН / Трек-номер',
      saveTracking: 'Сохранить ТТН',
      refiscalize: 'Повторная фискализация',
      archive: 'В архив',
      restore: 'Восстановить',
      deleteForever: 'Удалить навсегда',
      hardDeleteConfirm: (id: number) => `Удалить заказ #${id} навсегда? Это действие необратимо.`,
      receipt: 'Чек',
      noReceipt: 'Без чека',
      status: {
        new: 'Новый',
        seen: 'В обработке',
        shipped: 'Отправлен',
        done: 'Выполнен',
        cancelled: 'Отменен',
        refunded: 'Возврат',
      },
      refundOrder: 'Возврат (Refund)',
      refundReasonPrompt: 'Укажите причину возврата:',
      refundSuccess: 'Возврат успешно оформлен!',
      refundFailed: 'Ошибка при оформлении возврата',
      cancelOrder: 'Отменить заказ',
      pendingQuestionsCount: (n: number) => `${n} вопросов без ответа`,
      loadingQuestions: 'Загрузка вопросов...',
      noQuestionsText: 'Клиенты еще не задавали вопросов или все уже отвечены.',
      userId: 'Telegram ID',
      answerQuestion: 'Ответить на вопрос',
      answerText: 'Текст ответа',
      servicesDisabledText: 'Бронирование услуг отключено в глобальных настройках.',
      ordersText: 'Обрабатывайте новые заказы, оплату, доставку, фискализацию и архив без перехода в меню Telegram.',
      searchOrdersPlaceholder: 'Поиск (№ заказа, клиент, телефон, ТТН)...',
      exportCsv: 'Экспорт CSV',
      exportingCsv: 'Экспорт...',
      copyPhone: 'Скопировать телефон',
      copyAddress: 'Скопировать адрес',
      orderStatus: 'Статус',
      allStatuses: 'Все статусы',
      allPayments: 'Все оплаты',
      showArchive: 'Архив',
      ordersCount: (count: number) => `Заказы (${count})`,
      noOrders: 'Пока нет заказов',
      noOrdersFiltered: 'Нет заказов по выбранным фильтрам.',
      orderCardTitle: (id: number, date: string) => `Заказ #${id} · ${date}`,
      client: 'Клиент',
      items: 'Товары',
      changeStatus: 'Изменить статус',
      markPaid: 'Отметить как оплаченный',
      markUnpaid: 'Отметить как неоплаченный',
      archiveOrder: 'В архив',
      unarchiveOrder: 'Вернуть из архива',
      statusUpdated: 'Статус обновлен',
      paymentUpdated: 'Статус оплаты обновлен',
      archiveUpdated: 'Заказ обновлен',
      trackingNumber: 'ТТН / Трек-номер',
      setTracking: 'Сохранить ТТН',
      trackingSaved: 'ТТН сохранен',
      fiscalizeAction: 'Фискализировать (Checkbox)',
      fiscalizeSuccess: 'Чек успешно фискализирован!',
      fiscalizeError: 'Ошибка фискализации чека',
      fiscalReceipt: 'Фискальный чек',
      questionsNav: 'Вопросы',
      questionsTitle: 'Вопросы клиентов',
      questionsText: 'Отвечайте на вопросы клиентов из каталога и карточек товаров.',
      questionsPending: 'Ожидают ответа',
      questionsAnswered: 'Отвеченные',
      noQuestions: 'Нет вопросов',
      noQuestionsFiltered: 'Нет вопросов по выбранным фильтрам.',
      questionFrom: (name: string, date: string) => `От: ${name} · ${date}`,
      questionProduct: 'Товар:',
      answerPlaceholder: 'Введите ответ клиенту...',
      sendAnswer: 'Отправить ответ',
      answerSent: 'Ответ успешно отправлен клиенту в Telegram!',
      selectQuestion: 'Выберите вопрос',
      questionAnswered: 'Вопрос уже отвечен',
      questionAnswerFailed: 'Не удалось отправить ответ',
      answerRequired: 'Введите текст ответа',
      storesText: 'Создание и управление филиалами и магазинами платформы.',
      storeEditorTitle: 'Редактирование магазина',
      storeEditorText: 'Настройте название, логотип и контакты магазина.',
      createStoreTitle: '➕ Новый магазин',
      createStoreText: 'Создайте новый филиал или бренд-магазин.',
      createStoreAction: 'Создать магазин',
      createAnotherStore: 'Создать еще один магазин',
      createAnotherStoreText: 'Добавьте дополнительный магазин в систему.',
      storeSaved: 'Магазин сохранен',
      storeCreated: 'Магазин успешно создан!',
      storeActive: 'Активен',
      storeInactive: 'Выключен',
      storeActivate: 'Включить магазин',
      storeDeactivate: 'Выключить магазин',
      storeToggled: 'Статус магазина изменен',
      staffTitle: 'Персонал и Продавцы',
      staffText: 'Управление ролями сотрудников, менеджеров и доступом продавцов.',
      staffTab: 'Сотрудники',
      sellersTab: 'Продавцы (Маркетплейс)',
      addStaffTitle: 'Добавить сотрудника',
      staffUserId: 'Telegram User ID',
      staffRole: 'Роль',
      staffName: 'Имя сотрудника',
      staffEmail: 'Email сотрудника',
      addStaffAction: 'Добавить в команду',
      staffAdded: 'Сотрудник добавлен!',
      removeStaffConfirm: 'Удалить этого сотрудника из команды?',
      staffRemoved: 'Сотрудник удален',
      noStaff: 'Пока нет добавленных сотрудников.',
      noSellers: 'Нет зарегистрированных продавцов.',
      sellerApprove: 'Одобрить продавца',
      sellerBlock: 'Заблокировать',
      sellerUnblock: 'Разблокировать',
      sellerApproved: 'Продавец одобрен!',
      sellerBlocked: 'Продавец заблокирован',
      sellerUnblocked: 'Продавец разблокирован',
      sellerPendingBadge: 'Ожидает модерации',
      sellerBlockedBadge: 'Заблокирован',
      sellerApprovedBadge: 'Одобрен',
      validationStaffUserIdRequired: 'Укажите Telegram ID пользователя',
      settingsTitle: 'Глобальные настройки',
      settingsText: 'Настройки магазина, валюты, платежных шлюзов, интеграций и резервных копий.',
      settingsSaved: 'Настройки успешно сохранены!',
      settingsSectionGeneral: 'Основные настройки',
      maintenanceMode: 'Режим технического обслуживания',
      maintenanceModeText: 'При включении клиенты увидят страницу технических работ.',
      maintenanceMessage: 'Сообщение техобслуживания',
      sellerRegistrationEnabled: 'Регистрация продавцов открыта',
      minOrderUah: 'Минимальная сумма заказа (UAH)',
      priceRounding: 'Округление цен',
      priceRoundingOff: 'Без округления',
      settingsSectionPayments: 'Платежные методы и реквизиты',
      bankRecipient: 'Получатель (ФОП / Название)',
      bankIban: 'Счет IBAN',
      bankExtraInfo: 'Дополнительная информация о платеже',
      lodgingDepositPercent: 'Процент предоплаты для бронирований (%)',
      customPaymentName: 'Название кастомного метода оплаты',
      customPaymentDescription: 'Описание кастомного метода оплаты',
      paymentMethodsEnabled: 'Включенные способы оплаты',
      settingsSectionAuth: 'Авторизация и безопасность',
      authProvidersEnabled: 'Провайдеры авторизации',
      settingsSectionBackup: 'Резервное копирование',
      autoBackupHour: 'Час автобэкапа (0-23, -1 для выключения)',
      gdriveEnabled: 'Автобэкап в Google Drive',
      gdriveFolderId: 'ID папки Google Drive',
      gdriveKeepBackups: 'Хранить последних копий',
      gdriveUploadSettings: 'Выгружать настройки в Drive',
      gdriveUploadPhotos: 'Выгружать фотографии в Drive',
      emailBackupEnabled: 'Отправлять резервную копию на Email',
      emailBackupEnabledText: 'Автоматическая доставка базы данных JSONL на ваш почтовый ящик',
      emailBackupAddress: 'Email для получения бэкапов',
      emailBackupAddressPlaceholder: 'admin@example.com',
      emailBackupAddressHint: 'Оставьте пустым для отправки на основной email заказов',
      emailBackupFrequency: 'Периодичность отправки на почту',
      emailBackupFreq1Day: 'Каждый день',
      emailBackupFreq2Days: 'Каждые 2 дня',
      emailBackupFreq3Days: 'Каждые 3 дня',
      emailBackupFreq7Days: 'Еженедельно (каждые 7 дней)',
      emailBackupFreq14Days: 'Каждые 2 недели',
      emailBackupFreq30Days: 'Ежемесячно (каждые 30 дней)',
      emailBackupFrequencyHint: 'Бэкап будет отправляться не чаще указанного интервала в установленный час автобэкапа',
      emailBackupLastSent: 'Последний бэкап на почту отправлен',
      downloadBackupNow: 'Скачать резервную копию базы',
      settingsSectionSeo: 'SEO и Google Аналитика',
      googleSiteVerification: 'Google Site Verification Code',
      googleSiteVerificationText: 'Код подтверждения для Google Search Console.',
      ga4MeasurementId: 'Google Analytics 4 Measurement ID (G-...)',
      ga4MeasurementIdText: 'Идентификатор потока данных Google Analytics 4.',
      settingsSectionMedia: 'Медиа и YouTube',
      youtubeChannelId: 'ID YouTube канала',
      youtubeChannelIdText: 'Для интеграции с видеообзорами и шортсами.',
      settingsSectionEmail: 'Email уведомления и SMTP',
      smtpStatusTitle: 'Статус SMTP сервера',
      smtpConfiguredBadge: 'SMTP настроен',
      smtpNotConfiguredBadge: 'SMTP не настроен',
      ordersEmailLabel: 'Email для уведомлений о заказах',
      ordersEmailPlaceholder: 'orders@example.com',
      ordersEmailText: 'На этот адрес будут приходить копии всех новых заказов.',
      customerOrderEmailEnabled: 'Отправлять клиентам подтверждение на email',
      customerOrderEmailEnabledText: 'Отправляет клиенту чек и состав заказа при наличии email.',
      testEmailTitle: 'Тестовая отправка Email',
      testEmailPlaceholder: 'admin@example.com',
      testEmailSend: 'Отправить тест',
      testEmailSending: 'Отправка...',
      faqNav: 'FAQ (База знаний)',
      faqTitle: 'Вопросы и ответы (FAQ)',
      faqText: 'Управление часто задаваемыми вопросами и подсказками бота.',
      addFaqTitle: 'Добавить запись FAQ',
      editFaqTitle: 'Редактировать FAQ',
      faqQuestionUk: 'Вопрос на украинском',
      faqQuestionEn: 'Вопрос на английском',
      faqAnswerUk: 'Ответ на украинском',
      faqAnswerEn: 'Ответ на английском',
      faqKeywords: 'Ключевые слова (через запятую)',
      addFaqAction: 'Добавить FAQ',
      saveFaqAction: 'Сохранить изменения',
      faqAdded: 'Запись FAQ успешно добавлена!',
      faqSaved: 'Запись FAQ обновлена!',
      faqRemoved: 'Запись FAQ удалена',
      removeFaqConfirm: 'Удалить эту запись FAQ?',
      noFaq: 'Пока нет записей FAQ.',
      searchFaqPlaceholder: 'Поиск по FAQ...',
      noFaqFound: 'Ничего не найдено по вашему запросу.',
      edit: 'Редактировать',
      validationFaqQuestionRequired: 'Укажите вопрос на украинском',
      validationFaqAnswerRequired: 'Укажите ответ на украинском',
      analyticsNav: 'Аналитика',
      analyticsTitle: 'Аналитика продаж',
      analyticsText: 'Показатели выручки, динамика заказов и средний чек.',
      analyticsToday: 'Сегодня',
      analyticsWeek: '7 дней',
      analyticsMonth: '30 дней',
      analyticsAllTime: 'Все время',
      analyticsOrders: 'Заказы',
      analyticsRevenue: 'Выручка',
      analyticsAvgCheck: 'Средний чек',
      analyticsNewCustomers: 'Новые клиенты',
      analyticsReturningCustomers: 'Повторные заказы',
      analyticsRevenueTrend: 'Динамика выручки',
      auctionsNav: 'Аукционы',
      auctionsTitle: 'Управление аукционами',
      auctionsText: 'Создание лотов, мониторинг ставок и определение победителей.',
      auctionStatusActive: 'Активен',
      auctionStatusClosed: 'Завершен',
      auctionStatusCancelled: 'Отменен',
      auctionCurrentPrice: 'Текущая ставка',
      auctionStartPrice: 'Стартовая цена',
      auctionEndsAt: 'Окончание',
      auctionNoWinner: 'Без победителя',
      cancelAuction: 'Отменить аукцион',
      cancelAuctionConfirm: 'Вы уверены, что хотите отменить этот аукцион?',
      auctionCancelled: 'Аукцион отменен',
      noAuctions: 'Пока нет созданных аукционов.',
      createAuctionTitle: '➕ Создать новый аукцион',
      auctionProductId: 'Товар для аукциона',
      auctionStartPriceInput: 'Начальная цена (UAH)',
      auctionMinStep: 'Минимальный шаг ставки (UAH)',
      auctionDurationHours: 'Длительность (в часах)',
      auctionAutoExtend: 'Автопродление при ставке на последних минутах',
      createAuctionAction: 'Запустить аукцион',
      auctionCreated: 'Аукцион успешно создан и запущен!',
      validationAuctionProductRequired: 'Выберите товар для аукциона',
      validationAuctionPriceInvalid: 'Укажите корректную начальную цену',
      deliveryNav: 'Службы доставки',
      deliveryTitle: 'Способы доставки',
      deliveryText: 'Настройка доступных курьерских служб, почтоматов и самовывоза.',
      deliveryStatusActive: 'Активна',
      deliveryStatusInactive: 'Отключена',
      toggleDeliveryProvider: 'Переключить статус',
      deleteDeliveryProvider: 'Удалить',
      deleteDeliveryProviderConfirm: 'Удалить эту службу доставки?',
      noDeliveryProviders: 'Нет настроенных служб доставки.',
      createDeliveryProviderTitle: '➕ Добавить службу доставки',
      deliveryProviderNameUk: 'Название на украинском',
      deliveryProviderNameEn: 'Название на английском',
      deliveryProviderIcon: 'Иконка / Эмодзи',
      createDeliveryProviderAction: 'Добавить службу',
      deliveryProviderCreated: 'Служба доставки создана!',
      validationDeliveryNameRequired: 'Укажите название службы доставки',
      promoCodesNav: 'Промокоды',
      promoCodesTitle: 'Промокоды и Скидки',
      promoCodesText: 'Создание купонов на процентную или фиксированную скидку.',
      noPromoCodes: 'Пока нет активных промокодов.',
      pausePromoCode: 'Приостановить',
      resumePromoCode: 'Возобновить',
      deletePromoCode: 'Удалить',
      deletePromoCodeConfirm: 'Удалить этот промокод?',
      createPromoCodeTitle: '➕ Создать промокод',
      createPromoCodeHint: 'Укажите уникальный промокод и параметры скидки.',
      promoCode: 'Код промокода (напр. SUMMER2026)',
      promoDiscountPercent: 'Скидка в процентах (%)',
      promoDiscountFixed: 'Фиксированная скидка (UAH)',
      promoMaxUses: 'Максимум использований (0 для безлимита)',
      createPromoCodeAction: 'Создать промокод',
      promoCodeCreated: 'Промокод успешно создан!',
      validationPromoCodeRequired: 'Укажите код промокода',
      reviewsNav: 'Отзывы',
      reviewsTitle: 'Модерация отзывов',
      noReviews: 'Нет отзывов для модерации.',
      reviewApproved: 'Отзыв одобрен и опубликован на сайте!',
      reviewRejected: 'Отзыв отклонен',
      reviewDeleteConfirm: 'Удалить этот отзыв?',
      reviewDeleted: 'Отзыв удален',
      rating: 'Оценка',
      reviewAuthor: 'Автор',
      reviewComment: 'Текст отзыва',
      reviewDate: 'Дата',
      importExportNav: 'Импорт / Экспорт',
      importExportTitle: 'Импорт и Экспорт данных',
      importExportText: 'Массовая выгрузка и загрузка каталога товаров через CSV/JSON.',
      exportProductsCsv: 'Экспорт товаров в CSV',
      importProductsCsv: 'Импорт товаров из CSV',
      importProductsHint: 'Загрузите CSV-файл со структурой: name_uk, price, category, ...',
      chooseCsvFile: 'Выбрать CSV файл',
      startImport: 'Начать импорт',
      importing: 'Импорт товаров...',
      importSuccess: (count: number) => `Успешно импортировано ${count} товаров!`,
      importError: 'Ошибка при импорте файла',
      ordersStatusFilter: 'Фильтр по статусу',
      ordersDateRange: 'Период',
      customerProfile: 'Профиль клиента',
      orderTimeline: 'История заказа',
      deliveryAddress: 'Адрес доставки',
      orderTotal: 'Итого',
      fiscalCheckUrl: 'Ссылка на фискальный чек',
      sendTelegramNotification: 'Отправить уведомление в Telegram',
      notificationSent: 'Уведомление отправлено клиенту',
      notificationFailed: 'Не удалось отправить уведомление',

      badge: 'Админка',
      title: 'Управление магазином',
      backToShop: 'Назад в магазин',
      dashboard: 'Обзор',
      storesNav: 'Магазины',
      lodgingNav: 'Номера',
      products: 'Товары',
      bannersNav: 'Баннеры',
      bannersTitle: 'Баннеры главной страницы',
      bannersSubtitle: 'Управление слайдером баннеров на главной странице магазина.',
      addBannerAction: 'Добавить баннер',
      closeForm: 'Закрыть форму',
      createBannerTitle: '➕ Создание нового баннера',
      editBannerTitle: (id: number) => `Редактирование баннера #${id}`,
      bannerImageUrl: 'URL картинки',
      bannerImageUrlPlaceholder: '/shared-assets/banners/banner-name.png или https://...',
      readyPresets: 'Готовые шаблоны:',
      bannerAltText: 'Описание / Заголовок',
      bannerAltPlaceholder: 'Например: PANA DORA — Весенняя коллекция',
      bannerHref: 'Ссылка (href)',
      bannerHrefPlaceholder: '/catalog или /catalog?category=perfume',
      bannerPreview: 'Предварительный просмотр:',
      bannerActiveLabel: 'Показывать в карусели (Активный)',
      bannerActiveStatus: 'Активный',
      bannerInactiveStatus: 'Выключен',
      createBannerSubmit: 'Создать баннер',
      saveBannerChanges: 'Сохранить изменения',
      bannersListTitle: (count: number) => `Список баннеров (${count})`,
      loading: 'Загрузка...',
      loadingBanners: 'Загрузка...',
      noBanners: 'Баннеров пока нет. Нажмите «Добавить баннер» выше.',
      bannerAdded: 'Баннер успешно добавлен!',
      bannerSaved: 'Баннер успешно обновлен!',
      bannerDeleted: 'Баннер удален!',
      deleteBannerConfirm: 'Удалить этот баннер?',
      validationBannerUrlRequired: 'Необходимо указать URL картинки баннера',
      moveUp: 'Переместить вверх',
      moveDown: 'Переместить вниз',
      enableBanner: 'Включить',
      disableBanner: 'Выключить',
      noBannerTitle: 'Без названия',
      delete: 'Удалить',
      orders: 'Заказы',
      questions: 'Вопросы',
      services: 'Услуги',
      aiGuideNav: 'AI-помощник',
      staffNav: 'Персонал',
      settingsNav: 'Настройки',
      backupNav: 'Бекапы',
      navGroupOverview: 'Обзор',
      navGroupCatalog: 'Каталог',
      navGroupSales: 'Продажи',
      navGroupAdmin: 'Администрирование',
      scopeTitle: 'Уровень доступа',
      scopeHint: 'Первый этап: отдельное приложение для ежедневной работы продавца или менеджера.',
      welcome: 'Реакт-админка для операционной работы',
      dashboardTitle: 'Операционная панель магазина',
      dashboardText: 'Управляйте магазинами, товарами и заказами с одного экрана.',
      role: 'Роль',
      stores: 'Магазины',
      phase: 'Этап',
      phaseValue: 'Backoffice rollout',
      scopedStores: 'Доступные магазины',
      newOrders: 'Новые заказы',
      pendingQuestions: 'Вопросы',
      recentOrders: 'Последние заказы',
      recentOrdersText: 'Самые свежие заказы в вашем доступе.',
      openOrders: 'Открыть заказы',
      openQuestions: 'Открыть вопросы',
      stockSnapshot: 'Состояние товаров',
      attention: 'Требует внимания',
      attentionText: (unpaid: number, questions: number) =>
        `${unpaid} неоплаченных заказов · ${questions} вопросов без ответа`,
      allStores: 'Все доступные магазины',
      productsText: 'Список товаров уже отфильтрован по роли и магазинам.',
      productsCrudText: 'Безопасное создание, редактирование и удаление товаров.',
      storeFilter: 'Магазин',
      prevPage: 'Назад',
      nextPage: 'Далее',
      pageRange: (from: number, to: number, total: number) => `${from}-${to} из ${total}`,
      backToProducts: 'К списку товаров',
      currentScope: 'Текущий объем',
      currentCategory: 'Текущая категория',
      loadingProducts: 'Загрузка товаров...',
      loadingProductEditor: 'Загрузка редактора товара...',
      loadingServices: 'Загрузка услуг...',
      loadingOrders: 'Загрузка заказов...',
      madeToOrder: 'Под заказ',
      stockItem: 'Складской товар',
      inStock: 'В наличии',
      outOfStock: 'Нет в наличии',
      activeService: 'Активна',
      inactiveService: 'Скрыта',
      minutes: 'мин',
      daysShort: 'дн.',
      pcsShort: 'шт',
      editLater: 'Редактирование в следующей фазе',
      noProducts: 'Пока нет доступных товаров',
      noProductsText: 'Если вы ожидали товары здесь, проверим привязку продавца к магазину.',
      searchProductPlaceholder: 'Поиск по названию или ID...',
      filterAll: 'Все',
      categoryFilter: 'Категория',
      allCategories: 'Все категории',
      errorLoadingProducts: 'Не удалось загрузить товары.',
      noServices: 'Пока нет доступных услуг',
      noServicesText: 'Здесь появятся услуги из доступных магазинов.',
      errorLoadingServices: 'Не удалось загрузить услуги.',
      servicesText: 'Просматривайте услуги в доступных магазинах.',
      reviewsText: 'Отзыв появляется на странице товара только после одобрения здесь.',
      loadingReviews: 'Загрузка отзывов...',
      noPendingReviews: 'Нет отзывов на модерации.',
      approveReview: 'Одобрить',
      rejectReview: 'Отклонить',
      backupTitle: 'Резервные копии',
      backupText: 'Подключение Google Drive, мгновенный бекап, скачивание и восстановление базы.',
      gdriveConnectionTitle: 'Подключение Google Drive',
      gdriveConnectedAs: 'Подключено:',
      gdriveNotConnected: 'Google Drive не подключен.',
      gdriveNotConfigured: 'OAuth не настроен на сервере и нет service-account credentials.',
      gdriveConnect: 'Подключить Google Drive',
      gdriveDisconnect: 'Отключить',
      gdriveDisconnected: 'Google Drive отключен',
      backupActionsTitle: 'Действия',
      backupNowAction: 'Бекап в Google Drive сейчас',
      backupNowHint: 'Восстановление полностью заменяет текущую базу данных.',
      backupNowSuccess: (n: number) => `Загружено ${n} файл(ов) в Google Drive`,
      backupNowPartial: (n: number, failed: string) => `Загружено ${n} файл(ов), но не удалось: ${failed}`,
      backupNowFailed: 'Не удалось загрузить бекап в Google Drive',
      backupEmailNowAction: 'Бэкап на Email сейчас',
      backupEmailSuccess: (to: string, kb: number) => `Бэкап (${kb} KB) успешно отправлен на ${to}`,
      backupEmailFailed: 'Не удалось отправить бэкап на Email',
      loadingAnalytics: 'Загрузка аналитики...',
      loadFailed: 'Не удалось загрузить данные',
      downloadBackupAction: 'Скачать бекап (.jsonl)',
      restoreAction: 'Восстановить из файла',
      restoreConfirm: 'Текущая база данных будет полностью заменена содержимым этого файла. Продолжить?',
      restoreSuccess: (n: number) => `Восстановлено ${n} строк`,
      restoreFailed: 'Не удалось восстановить базу данных',
      logoFileId: 'Логотип магазина: Telegram file_id',
      contactsUk: 'Контакты на украинском',
      contactsEn: 'Контакты на английском',
      storeSlug: 'Slug магазина',
      noStores: 'Пока нет магазина',
      noStoresText: 'Создайте базовую карточку магазина, чтобы сразу перейти к товарам.',
      categoryCreateTitle: 'Категории магазина',
      categoryCreateText: 'Категории создаются отдельно и должны быть уникальными по названию.',
      categoryCreated: 'Категория создана',
      categoryNameTaken: 'Категория с таким названием уже существует',
      createCategoryAction: 'Создать категорию',
      validationStoreLogoRequired: 'Добавьте logo file_id магазина',
      validationStoreSlugRequired: 'Укажите slug магазина',
      validationStoreNameRequired: 'Укажите название магазина',
      selectProduct: 'Выберите товар',
      selectProductText: 'Справа откроется редактор только для доступного вам товара.',
      createProduct: 'Новый товар',
      createProductText: 'Сначала создаем товар с минимальным набором: название и категория.',
      createProductAction: 'Создать товар',
      saveChanges: 'Сохранить изменения',
      saving: 'Сохраняем...',
      productCreated: 'Товар создан',
      productSaved: 'Изменения сохранены',
      productDeleted: 'Товар удален',
      saveFailed: 'Не удалось сохранить изменения',
      deleteFailed: 'Не удалось удалить',
      deleteProduct: 'Удалить товар',
      deleteProductConfirm: 'Удалить этот товар?',
      itemRemoved: 'Элемент удален',
      productStore: 'Магазин товара',
      noStoreScope: 'Без отдельного магазина',
      productCategory: 'Категория',
      selectCategory: 'Выберите категорию',
      nameSingle: 'Название',
      nameUk: 'Название на украинском',
      nameEn: 'Название на английском',
      descriptionSingle: 'Описание',
      descriptionUk: 'Описание на украинском',
      descriptionEn: 'Описание на английском',
      descriptionTab: 'Описание',
      previousStep: 'Назад',
      nextStep: 'Далее',
      editSection: 'Редактировать',
      markdown: {
        source: 'Markdown',
        preview: 'Предпросмотр',
        empty: 'Описание появится здесь во время набора.',
        bold: 'Жирный текст',
        italic: 'Курсив',
        list: 'Список',
        link: 'Ссылка',
      },
      priceUsd: 'Цена в USD',
      productionDays: 'Дней на изготовление',
      readyToShip: 'Готов к отправке',
      basicInfoTitle: 'Базовая информация',
      basicInfoText: 'Названия, описания и категория.',
      productSlug: 'URL Slug',
      productSlugHelp: 'Прямая ссылка на товар: /product/slug или /app/catalog/slug',
      commerceTitle: 'Цена и наличие',
      commerceText: 'Отдельный блок для цены, статуса наличия и изготовления под заказ.',
      mediaTitle: 'Фото и видео',
      mediaText: 'Основное фото, галерея и YouTube редактируются отдельно.',
      mediaSummaryNoVideo: 'Без YouTube',
      telegramUploadTitle: 'Быстрое добавление фото через Telegram',
      telegramUploadText: 'Если вам удобнее работать через Telegram, откройте бота там.',
      openTelegramBot: 'Открыть бота',
      refreshProductCard: 'Обновить карточку',
      noPrimaryPhoto: 'Нет фото',
      youtubeLink: 'YouTube-ссылка',
      primaryPhotoFileId: 'Основное фото: Telegram file_id',
      primaryPhotoSourceUrl: 'Основное фото: source URL',
      galleryTitle: 'Галерея',
      galleryText: 'Добавляйте отдельные фото галереи через file_id.',
      galleryPhotoFileId: 'Фото галереи: Telegram file_id',
      galleryPhotoSourceUrl: 'Фото галереи: source URL',
      addGalleryPhoto: 'Добавить фото в галерею',
      photoAdded: 'Фото добавлено',
      photoReordered: 'Порядок фотографий обновлен',
      primaryPhotoLabel: 'Основное фото',
      galleryPhotoLabel: 'Фото галереи',
      makePrimaryPhoto: 'Сделать главным',
      movePhotoUp: 'Вверх',
      movePhotoDown: 'Вниз',
      deletePhotoConfirm: 'Удалить это фото?',
      optionsTitle: 'Опции и варианты',
      optionsText: 'Группы опций и варианты добавляются отдельно.',
      specsTitle: 'Характеристики',
      specsText: 'Ключевые свойства товара для карточки, фильтров и сравнения.',
      specsSummary: 'редактируемые характеристики',
      specNameSingle: 'Характеристика',
      specNameUk: 'Характеристика на украинском',
      specNameEn: 'Характеристика на английском',
      specValueSingle: 'Значение',
      specValueUk: 'Значение на украинском',
      specValueEn: 'Значение на английском',
      sortOrder: 'Порядок сортировки',
      addSpec: 'Добавить характеристику',
      saveSpec: 'Сохранить характеристику',
      specAdded: 'Характеристика добавлена',
      specSaved: 'Характеристика сохранена',
      deleteSpecConfirm: 'Удалить эту характеристику?',
      kitTabTitle: 'Комплект',
      kitTabText: 'Сделайте этот товар набором из других товаров.',
      kitIsKitBadge: 'Это комплект',
      kitNoItems: 'В комплект еще не добавлены товары.',
      kitAddItemTitle: 'Добавить товар в комплект',
      kitSearchPlaceholder: 'Начните вводить название товара…',
      kitNoSearchResults: 'Ничего не найдено.',
      kitAddAction: 'Добавить',
      kitSearchScopeHint: 'Поиск среди первых 50 товаров этого магазина.',
      kitQuantity: 'Количество',
      kitSaveAction: 'Сохранить состав комплекта',
      kitSaved: 'Состав комплекта сохранен',
      addOption: 'Добавить опцию',
      optionAdded: 'Опция добавлена',
      optionNameSingle: 'Опция',
      optionNameUk: 'Опция на украинском',
      optionNameEn: 'Опция на английском',
      deleteOptionConfirm: 'Удалить эту опцию вместе с её вариантами?',
      addVariant: 'Добавить вариант',
      variantAdded: 'Вариант добавлен',
      variantNameSingle: 'Вариант',
      variantNameUk: 'Вариант на украинском',
      variantNameEn: 'Вариант на английском',
      variantPriceDiff: 'Надбавка в USD',
      variantPhotoFileId: 'Variant photo file_id',
      defaultVariant: 'Вариант по умолчанию',
      deleteVariantConfirm: 'Удалить этот вариант?',
      remove: 'Удалить',
      variantStock: 'Остаток',
      variantStockUnlimited: 'Без учета',
      saveStock: 'Сохранить',
      stockSaved: 'Остаток обновлен',
      validationCategoryRequired: 'Выберите категорию',
      validationNameRequired: 'Укажите название на украинском',
      validationPriceInvalid: 'Укажите корректную цену в USD',
      validationYoutubeInvalid: 'Укажите корректную ссылку на YouTube',
      validationDaysInvalid: 'Дни изготовления должны быть от 0 до 365',
      validationPhotoRequired: 'Укажите Telegram file_id для фото',
      validationOptionRequired: 'Укажите название опции на украинском',
      validationVariantRequired: 'Укажите название варианта на украинском',
      validationVariantPriceInvalid: 'Укажите корректную надбавку для варианта',
      validationVariantStockInvalid: 'Остаток должен быть целым неотрицательным числом',
      validationSpecNameRequired: 'Укажите название характеристики на украинском',
      validationSpecValueRequired: 'Укажите значение характеристики на украинском',
      validationSpecSortInvalid: 'Порядок сортировки должен быть числом от 0 до 365',
      noAccessTitle: 'Нет доступа к админке',
      noAccessText: 'Это отдельное приложение доступно продавцам и менеджерам.',
      loginRequiredTitle: 'Требуется вход',
      loginRequiredText: 'Сначала войдите в магазин, затем откройте админку.',
      openLogin: 'Открыть вход',
      serverErrorTitle: 'Ошибка сервера',
      serverErrorText: 'Не удалось связаться с сервером или произошла ошибка. Попробуйте обновить страницу.',
      retry: 'Попробовать снова',
      fillWithAi: '✨ Заполнить с ИИ',
      aiModalTitle: 'Вставьте описание или сырой текст товара для распознавания ИИ',
      aiModalPlaceholder: 'Скопируйте сюда текст с сайта поставщика, ноты аромата, название или цену...',
      aiParseAction: '🪄 Распарсить и заполнить',
      aiParsing: 'Распознавание...',
      aiParseError: 'Не удалось распознать текст через ИИ',
      closeAction: 'Закрыть',
      specsTab: 'Характеристики',
      specsSubtitle: 'Задайте ноты, концентрацию, семейство ароматов и другие атрибуты',
      specsEmpty: 'У этого товара еще нет характеристик.',
      specCode: 'Код характеристики',
      specCodeSlug: 'Код характеристики (slug)',
      addSpecTitle: 'Добавить новую характеристику',
      addSpecSubtitle: 'Выберите известный шаблон или создайте собственный атрибут',
      specPresetsLabel: 'Быстрые пресеты из каталога:',
      specCachedValuesLabel: 'Существующие значения в кэше:',
      addVariantGroupTitle: 'Создать новую группу опций (например: Объем)',
      addVariantToOptionTitle: 'Добавить вариант опции',
      addGalleryPhotoTitle: 'Добавить фото в галерею',
      seoTab: 'SEO / Google Оптимизация',
      seoTagsTitle: 'Настройка SEO тегов',
      seoTagsSubtitle: 'Задайте уникальные заголовки и описания для поисковых систем Google',
      metaTitleUk: 'Meta Title (UK) — Заголовок в Google',
      metaTitleEn: 'Meta Title (EN)',
      metaDescriptionUk: 'Meta Description (UK) — Описание в результатах поиска',
      metaDescriptionEn: 'Meta Description (EN)',
      seoAuditTitle: 'SEO / Google Аудит',
      seoAuditSubtitle: 'Предпросмотр в Google и аудит оптимизации товара',
      roleManager: 'Менеджер (manager)',
      roleSuperadmin: 'Суперадмин (superadmin)',
      roleSeller: 'Продавец (seller)',
      phonePlaceholderLabel: 'Пример телефона для клиентов (Phone Placeholder)',
      phonePlaceholderText: 'Пример формата номера телефона в полях ввода для клиентов независимо от страны.',
      metaPixelId: 'Meta / Facebook Pixel ID',
      metaPixelIdText: 'ID пикселя Meta/Facebook для отслеживания конверсий и ретаргетинга в Instagram и Facebook.',
      aiAgentTokenSectionTitle: '🔑 Доступ для ИИ-Агента (AI Agent Access)',
      aiAgentTokenSectionText: 'Сгенерируйте короткоживущий или одноразовый API-токен для передачи ИИ-агенту (Antigravity, Claude, Gemini). Агент будет выполнять вызовы API от вашего имени.',
      aiAgentTokenTtl: 'Время действия токена (TTL)',
      aiAgentTokenTtl15m: '15 минут',
      aiAgentTokenTtl1h: '1 час (60 мин)',
      aiAgentTokenTtl6h: '6 часов',
      aiAgentTokenTtl24h: '24 часа (1 день)',
      aiAgentTokenTaskLabel: 'Название задачи / примечание (необязательно)',
      aiAgentTokenTaskPlaceholder: 'напр. Добавить новый парфюм Creed Aventus',
      aiAgentTokenSingleUse: 'Одноразовый токен (single-use) — токен сгорит сразу после первого использования',
      aiAgentTokenGenerate: '🔑 Сгенерировать токен для AI',
      aiAgentTokenGenerating: 'Генерация...',
      aiAgentTokenReady: 'Ваш токен для ИИ-агента готов!',
      aiAgentTokenSingleUseBadge: '⚡ Одноразовый',
      aiAgentTokenValidTtl: '⏳ Действителен {ttl} мин',
      aiAgentTokenCopyPrompt: '📋 Скопировать промпт для ИИ в 1 клик',
      aiAgentTokenCopied: 'Скопировано! ✅',
      aiAgentTokenError: 'Ошибка выпуска токена',
      validationDepositPercentInvalid: 'Процент предоплаты должен быть от 0 до 100',
      validationBackupHourInvalid: 'Час автобэкапа должен быть от -1 до 23',
      deliveryAutomationTitle: 'Автоматизация доставки',
      deliveryAutomationText: 'Автоматическое обновление статусов заказов и уведомления клиентов (Новая Почта / Укрпочта).',
      deliveryAutoDone: 'Авто-завершение заказов',
      deliveryAutoDoneDesc: 'Автоматически переводить заказы в статус "Выполнен", когда посылка получена клиентом.',
      deliveryArrivedNotify: 'Уведомления о прибытии',
      deliveryArrivedNotifyDesc: 'Отправлять клиенту уведомление в Telegram, когда посылка прибывает в отделение или почтомат.',
      viewModeList: 'Список',
      viewModeReview: 'Ревью заказов',
      orderReviewTitle: 'Пошаговая обработка заказов',
      orderReviewCounter: (current: number, total: number) => `Заказ ${current} из ${total}`,
      orderReviewNext: 'Следующий',
      orderReviewPrev: 'Предыдущий',
      orderReviewRecommendedAction: 'Рекомендуемое действие',
      orderReviewConfirmStatus: (id: number, status: string) => `Изменить статус заказа #${id} на «${status}»?`,
      orderReviewDeliveryDetails: 'Детали доставки',
      orderReviewCity: 'Город',
      orderReviewWarehouse: 'Отделение / адрес',
      orderReviewCustomer: 'Клиент',
      orderReviewPhone: 'Телефон',
      orderReviewComment: 'Комментарий клиента',
      orderReviewItems: 'Состав заказа',
      orderReviewCopyRequisites: 'Скопировать реквизиты',
      orderReviewRequisitesCopied: 'Реквизиты скопированы',
      orderReviewActionConfirmOrder: 'Подтвердить заказ',
      orderReviewActionMarkShipped: 'Отметить отправленным',
      orderReviewActionMarkDone: 'Отметить выполненным',
      orderReviewQueueAll: 'Все заказы',
      orderReviewQueuePending: 'Требуют обработки',
      orderReviewQueueProcessing: 'В обработке',
      statusConfirmPrompt: (id: number, status: string) => `Изменить статус заказа #${id} на «${status}»?`,
      dismiss: 'Закрыть',
    },
  }
} as const

type Lang = keyof typeof TRANSLATIONS
type AppTranslations = (typeof TRANSLATIONS)['uk']

function resolveLang(lang: string): Lang {
  if (lang === 'en') return 'en'
  if (lang === 'ru') return 'ru'
  return 'uk'
}

export function useT<N extends keyof AppTranslations>(namespace: N): AppTranslations[N] {
  const lang = useAppStore((s) => s.lang)
  return getT(lang, namespace)
}

export function getT<N extends keyof AppTranslations>(
  lang: string,
  namespace: N,
): AppTranslations[N] {
  const resolved = resolveLang(lang)
  const base = TRANSLATIONS.uk[namespace] as Record<string, unknown>
  if (resolved === 'uk') return base as AppTranslations[N]
  const target = TRANSLATIONS[resolved][namespace] as Record<string, unknown>
  return {
    ...base,
    ...target,
  } as AppTranslations[N]
}
